<template>
  <div class="sketchpad" :class="employee_full_status ? 'sketchpad-full' : ''">
    <!-- 畫板頭部 -->
    <transition name="el-fade-in">
      <div class="sketchpad-head">
        <div class="sketchpad-head-left" v-show="!employee_full_status">
          <!--<p>Practical English</p>-->
          <span v-if="MaterialFileName">{{ MaterialName }}</span>
          <img
            v-if="MaterialFileName"
            src="@/assets/image/icon-right.png"
            alt=""
          />
          <span v-if="MaterialUnit">{{ MaterialUnit }}</span>
          <img v-if="MaterialUnit" src="@/assets/image/icon-right.png" alt="" />
          <span v-if="MaterialUnitPage">{{ MaterialUnitPage }}</span>
          <img
            v-if="MaterialUnitPage"
            src="@/assets/image/icon-right.png"
            alt=""
          />
          <span v-if="MaterialName">{{ MaterialFileName }}</span>
        </div>
      </div>
    </transition>
    <!-- 畫板內容 -->
    <div class="sketchpad-box">
      <div class="sketchpad-box-left" style="visibility: hidden">
        <!-- 放大 -->
        <div
          class="left-box"
          :class="toolzoomStatus ? 'tool-btns' : 'tool-btn'"
          @click="setZoom(0.05)"
        >
          <img
            v-if="!toolzoomStatus"
            src="@/assets/image/icon-tool11-close.png"
            alt=""
          />
          <img
            v-if="toolzoomStatus"
            src="@/assets/image/icon-tool11-open.png"
            alt=""
          />
        </div>
        <!-- 縮小 -->
        <div
          class="left-box"
          :class="toolshrinkStatus ? 'tool-btns' : 'tool-btn'"
          @click="setZoom(-0.05)"
        >
          <img
            v-if="!toolshrinkStatus"
            src="@/assets/image/icon-tool12-close.png"
            alt=""
          />
          <img
            v-if="toolshrinkStatus"
            src="@/assets/image/icon-tool12-open.png"
            alt=""
          />
        </div>
      </div>
      <div class="sketchpad-box-right">
        <div class="sketchpad-box-right-head whiteboard-wrapper">
          <div
            class="sketchpad-box-right-head"
            ref="whiteboardContainer"
            id="whiteboardContainer"
            style="
              position: relative;
              overflow: auto;
              height: 100%;
              width: 100%;
            "
          >
            <Loading
              v-show="loadingMedia"
              id="loadingMedia"
              style="display: none; width: 100%; height: 100%"
            ></Loading>
          </div>
          <div
            class="custom-scrollbar-horizontal"
            ref="customScrollbarHorizontal"
            :style="{
              width: scrollbarWidth + 'px',
              top: employee_full_status ? '0px' : 'auto',
            }"
            @mousedown.prevent
          >
            <div
              class="scrollbar-thumb-horizontal"
              ref="scrollbarThumbHorizontal"
              :style="{ left: thumbLeft + 'px', width: thumbWidth + 'px' }"
              @mousedown.prevent="startHorizontalDrag"
            ></div>
          </div>
          <div
            class="custom-scrollbar"
            ref="customScrollbar"
            :style="{ height: scrollbarHeight + 'px' }"
            @mousedown.prevent
          >
            <div
              class="scrollbar-thumb"
              ref="scrollbarThumb"
              :style="{ top: thumbTop + 'px', height: thumbHeight + 'px' }"
              @mousedown.prevent="startDrag"
            ></div>
          </div>
        </div>
        <div class="sketchpad-box-right-foo" v-if="!employee_full_status">
          <div class="foo-left"></div>
          <div class="foo-right">
            <div class="foo-media" v-show="mediaShow">
              <div class="media-wrapper">
                <audio
                  ref="audio"
                  id="main_audio"
                  preload="none"
                  playsinline
                  controls
                  style="width: 100%"
                  :src="mediaSelected"
                  @volumechange="handleVolumeChange"
                >
                  <source :src="mediaSelected" type="audio/mp3" />
                </audio>
              </div>
              <div
                class="foo-media-btn"
                v-if="fileSelectCheck.FileType != 'audio/mp3'"
                type="button"
                id="button_hi_popup_video"
                ref="popupButton"
              >
                <img src="@/assets/image/icon-play-open.png" alt="" />
              </div>
              <div
                v-if="fileSelectCheck.FileType === 'audio/mp3'"
                class="foo-media-btn disabled"
              >
                <img
                  v-if="!mediaPlayStatus"
                  src="@/assets/image/icon-play-open.png"
                  alt=""
                />
                <img
                  v-if="mediaPlayStatus"
                  src="@/assets/image/icon-pause-open.png"
                  alt=""
                />
              </div>
              <div
                id="media-stop-btn"
                class="foo-media-btn disabled"
              >
                <img
                  v-if="mediaStopStatus"
                  src="@/assets/image/icon-stop-open.png"
                  alt=""
                />
                <img
                  v-if="!mediaStopStatus"
                  src="@/assets/image/icon-stop-dis.png"
                  alt=""
                />
              </div>
              <div class="foo-media-time">
                {{ formatTime(mediaCurrentDuration) }}
              </div>
              <div class="foo-media-slider">
                <el-slider
                  v-model="mediaSlider"
                  :show-tooltip="false"
                  @change="inputTimeUpdate()"
                  @mouseup="handleSliderMouseUp"
                ></el-slider>
              </div>
              <div class="foo-media-time">
                {{ formatTime(mediaTotalDuration) }}
              </div>
            </div>
            <div class="foo-volume" v-show="volumeShow">
              <!-- 大屏幕橫向展示 -->
              <!-- <div class="volume-btn" @click="volumeClick">
                <img
                  v-if="!volumeStatus"
                  src="@/assets/image/icon-volume-open.png"
                  alt=""
                />
                <img
                  v-if="volumeStatus"
                  src="@/assets/image/icon-volume-close.png"
                  alt=""
                />
              </div>
              <div class="volume-slider">
                <el-slider
                  v-model="volumeSlider"
                  :show-tooltip="false"
                  @change="volumeChange"
                ></el-slider>
              </div> -->
              <!-- 小屏幕豎向展示 -->
              <div class="volume-btn volume-btn-show" @click="volumeClick">
                <el-popover
                  placement="top"
                  trigger="hover"
                  popper-class="sketchpad-popovers"
                >
                  <el-slider
                    height="80px"
                    vertical
                    v-model="volumeSlider"
                    @change="volumeChange"
                  ></el-slider>
                  <img
                    v-if="!volumeStatus"
                    slot="reference"
                    src="@/assets/image/icon-volume-open.png"
                    alt=""
                  />
                  <img
                    v-if="volumeStatus"
                    slot="reference"
                    src="@/assets/image/icon-volume-close.png"
                    alt=""
                  />
                </el-popover>
              </div>
            </div>
            <div class="foo-full" @click="fullChange">
              <img src="@/assets/image/icon-full-open.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 全屏模式的音頻操作 -->
    <transition name="el-zoom-in-bottom">
      <div
        class="sketchpad-box-right-bottom"
        v-show="employee_full_status && fullBottomShow"
        @mouseover="fullBottomMouseover"
        @mouseleave="fullBottomMouseleave"
      >
        <div class="bottom-slider">
          <el-slider
            v-model="mediaSlider"
            v-if="mediaShow"
            disabled
            :show-tooltip="false"
            @change="mediaChange"
          ></el-slider>
        </div>
        <div class="bottom-box">
          <div class="bottom-box-left">
            <div
              class="bottom-media-btn"
              style="cursor: no-drop"
              v-if="mediaShow"
            >
              <img src="@/assets/image/icon-play-dis.png" alt="" />
            </div>
            <div
              class="bottom-media-btn"
              style="cursor: no-drop"
              v-if="mediaShow"
            >
              <img src="@/assets/image/icon-stop-dis.png" alt="" />
            </div>
            <div class="bottom-media-time" v-if="mediaShow">
              {{ mediaCurrentDuration }} / {{ mediaTotalDuration }}
            </div>
          </div>
          <div class="bottom-box-right">
            <div
              class="bottom-media-volume"
              v-if="volumeShow"
              @click="volumeClick"
            >
              <img
                v-if="!volumeStatus"
                src="@/assets/image/icon-volume-open.png"
                alt=""
              />
              <img
                v-if="volumeStatus"
                src="@/assets/image/icon-volume-close.png"
                alt=""
              />
            </div>
            <div class="bottom-media-slider" v-if="volumeShow">
              <el-slider
                v-model="volumeSlider"
                :show-tooltip="false"
                @change="volumeChange"
              ></el-slider>
            </div>
            <div
              class="bottom-media-btn"
              @click="fullChange"
              v-if="employee_full_status"
            >
              <img src="@/assets/image/icon-full-close.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- 全屏模式下 鼠標滑上觸發展示塊 -->
    <div class="sketchpad-full-bottom" @mouseover="fullBottomMouseover"></div>

    <transition name="el-zoom-in-bottom">
      <div
        class="video-container blur"
        id="hi_popup_video"
        @mouseover="videoMouseOver"
        @mouseleave="videoMouseleave"
        v-show="isShowVideoModal"
      >
        <div class="content">
          <div class="video-content" id="video-content">
            <div class="video-header" v-show="videoBottomShow">
              <h5 class="video-title">
                {{ mediaVideoNameSelected }}
              </h5>
              <button
                type="button"
                class="btn-close disabled"
                aria-label="Close"
                @click="closeVideoDialogSocket"
              ></button>
            </div>
            <video
              width="100%"
              height="100%"
              :key="mediaVedioSelected"
              ref="video"
              @loadedmetadata="setDuration"
              preload="metadata"
              playsinline
              @click.prevent="onVideoTapUnlock"
            >
              <source :src="mediaVedioSelected" type="video/mp4" />
              <!-- <source
                src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4"
                type="video/mp4"
              /> -->
              Your browser does not support the video tag.
            </video>
            <div
              class="video-footer"
              id="video-footer"
              v-show="videoBottomShow"
            >
              <div class="bottom-slider">
                <el-slider
                  v-model="currentTimeVideo"
                  :show-tooltip="false"
                  :max="duration"
                  @change="changeCurrentTime"
                ></el-slider>
              </div>
              <div class="bottom-box">
                <div class="bottom-box-left">
                  <div
                    class="bottom-media-btn video-control disabled"
                    @click="playVideo"
                  >
                    <img
                      v-if="isPlay"
                      src="@/assets/image/icon-play-dis.png"
                      alt=""
                    />
                    <img
                      v-if="!isPlay"
                      src="@/assets/image/icon-play-open.png"
                      alt=""
                    />
                  </div>
                  <div
                    class="bottom-media-btn video-control disabled"
                    @click="pauseVideo"
                  >
                    <img
                      v-if="!isPlay"
                      src="@/assets/image/icon-stop-dis.png"
                      alt=""
                    />
                    <img
                      v-if="isPlay"
                      src="@/assets/image/icon-stop-open.png"
                      alt=""
                    />
                  </div>
                  <div class="bottom-media-time">
                    {{ formatTime(currentTimeVideo) }} /
                    {{ formatTime(duration) }}
                  </div>
                </div>
                <div class="bottom-box-right">
                  <div class="bottom-media-volume" @click="toggleMute">
                    <img
                      v-if="!isMuted"
                      src="@/assets/image/icon-volume-open.png"
                      alt=""
                    />
                    <img
                      v-if="isMuted"
                      src="@/assets/image/icon-volume-close.png"
                      alt=""
                    />
                  </div>
                  <div class="bottom-media-slider">
                    <el-slider
                      v-model="volume"
                      :show-tooltip="false"
                      @change="changeVolume"
                      :min="0"
                      :max="1"
                      :step="0.01"
                    ></el-slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="el-fade-in">
      <div class="popup" v-show="screenEntry">
        <transition name="el-zoom-in-center">
          <div class="popup-box screenEntry-box" v-if="screenEntry">
            <h3 class="box-h3">
              請點擊下方「準備加入課堂」<br />
              並選擇「Chrome分頁」以進入課堂
            </h3>
            <h5 class="box-h5">
              Click the button below and select "Chrome Tab" to <br />
              get ready to join the class.
            </h5>
            <div class="box-btn">
              <button @click="screenEntryClose">
                <p>準備加入課堂</p>
                <span>Get ready to join the class.</span>
              </button>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { uuid } from "vue-uuid";
import axios from "axios";
import moment from "moment";
import { io } from "socket.io-client";
import whiteboard from "../../../jswb/whiteboard";
import keybinds from "../../../jswb/keybinds";
import Picker from "vanilla-picker";
// import { dom } from "@fortawesome/fontawesome-svg-core";
import shortcutFunctions from "../../../jswb/shortcutFunctions";
import ReadOnlyService from "../../../jswb/services/ReadOnlyService";
import InfoService from "../../../jswb/services/InfoService";
import { getSubDir } from "../../../jswb/utils";
import ConfigService from "../../../jswb/services/ConfigService";
import { v4 as uuidv4 } from "uuid";
import { throttle } from "lodash";
import Loading from "../components/Loading.vue";
import Notification from "../../../static/components/Notification.vue";
const urlParams = new URLSearchParams(window.location.search);
let whiteboardId = urlParams.get("whiteboardid");
const randomid = urlParams.get("randomid");
let colorPickerOnOpen = function (current_color) {
  this._domPalette = $(".picker_palette", this.domElement);
  const palette = JSON.parse(localStorage.getItem("savedColors"));
  if ($(".picker_splotch", this._domPalette).length === 0) {
    for (let i = 0; i < palette.length; i++) {
      let palette_Color_obj = new this.color.constructor(palette[i]);
      let splotch_div = $(
        '<div style="position:relative;"><span position="' +
          i +
          '" class="removeColor" style="position:absolute; cursor:pointer; right:-1px; top:-4px;">x</span></div>'
      )
        .addClass("picker_splotch")
        .attr({
          id: "s" + i,
        })
        .css("background-color", palette_Color_obj.hslaString)
        .on("click", { that: this, obj: palette_Color_obj }, function (e) {
          e.data.that._setColor(e.data.obj.hslaString);
        });
      splotch_div.find(".removeColor").on("click", function (e) {
        e.preventDefault();
        $(this).parent("div").remove();
        palette.splice(i, 1);
        localStorage.setItem("savedColors", JSON.stringify(palette));
      });
      this._domPalette.append(splotch_div);
    }
  }
};
const colorPickerTemplate = `
        <div class="picker_wrapper" tabindex="-1">
          <div class="picker_arrow"></div>
          <div class="picker_hue picker_slider">
            <div class="picker_selector"></div>
          </div>
          <div class="picker_sl">
            <div class="picker_selector"></div>
          </div>
          <div class="picker_alpha picker_slider">
            <div class="picker_selector"></div>
          </div>
          <div class="picker_palette"></div>
          <div class="picker_editor">
            <input aria-label="Type a color name or hex value"/>
          </div>
          <div class="picker_sample"></div>
          <div class="picker_done">
            <button>Ok</button>
          </div>
          <div class="picker_cancel">
            <button>Cancel</button>
          </div>
        </div>
      `;

let signaling_socket;

export default {
  name: "employee-sketchpad",
  components: {
    Loading,
  },
  data() {
    return {
      // 音視頻下拉選
      fileSelectCheck: {},
      // 音視頻列表
      fileSelectList: [
        {
          label: "音檔",
          list: [
            // { type: 1, id: 'A1', label: 'A0001.mp3' },
            // { type: 1, id: 'A2', label: 'A0002.mp3' },
            // { type: 1, id: 'A3', label: 'A0003.mp3' },
          ],
        },
        {
          label: "影片",
          list: [
            // { type: 2, id: 'B1', label: 'B0001.mp4' },
            // { type: 2, id: 'B2', label: 'B0002.mp4' },
            // { type: 2, id: 'B3', label: 'B0003.mp4' },
            // { type: 2, id: 'B4', label: 'B0004.mp4' },
            // { type: 2, id: 'B5', label: 'B0005.mp4' },
          ],
        },
      ],
      // 蓋章列表
      stampList: [
        {
          file: require("@/assets/image/stampList/icon_001_b_r.png"),
          name: "icon_001_b_r",
        },
        {
          file: require("@/assets/image/stampList/icon_002_b_r.png"),
          name: "icon_002_b_r",
        },
        {
          file: require("@/assets/image/stampList/icon_003_b_r.png"),
          name: "icon_003_b_r",
        },
        {
          file: require("@/assets/image/stampList/icon_004_b_r.png"),
          name: "icon_004_b_r",
        },
        {
          file: require("@/assets/image/stampList/icon_005_b_r.png"),
          name: "icon_005_b_r",
        },
        {
          file: require("@/assets/image/stampList/icon_006_b_r.png"),
          name: "icon_006_b_r",
        },
        {
          file: require("@/assets/image/stampList/Amazing.png"),
          name: "Amazing",
        },
        {
          file: require("@/assets/image/stampList/English_Star.png"),
          name: "English_Star",
        },
        {
          file: require("@/assets/image/stampList/Excellent.png"),
          name: "Excellent",
        },
        {
          file: require("@/assets/image/stampList/Great_Work.png"),
          name: "Great_Work",
        },
        {
          file: require("@/assets/image/stampList/HomeWork.png"),
          name: "HomeWork",
        },
        {
          file: require("@/assets/image/stampList/Improving.png"),
          name: "Improving",
        },
        {
          file: require("@/assets/image/stampList/Keep_Up.png"),
          name: "Keep_Up",
        },
        {
          file: require("@/assets/image/stampList/Outstanding.png"),
          name: "Outstanding",
        },
        {
          file: require("@/assets/image/stampList/Progressed.png"),
          name: "Progressed",
        },
        {
          file: require("@/assets/image/stampList/Remember.png"),
          name: "Remember",
        },
        {
          file: require("@/assets/image/stampList/Terrific.png"),
          name: "Terrific",
        },
        {
          file: require("@/assets/image/stampList/Very_Good.png"),
          name: "Very_Good",
        },
        {
          file: require("@/assets/image/stampList/Well_Done.png"),
          name: "Well_Done",
        },
      ],

      // 工具欄選中狀態-放大
      toolzoomStatus: false,
      // 工具欄選中狀態-縮小
      toolshrinkStatus: false,

      // 媒體操作-顯示狀態
      mediaShow: true,
      // 媒體播放-當前時長
      mediaCurrentDuration: 0,
      // 媒體播放-總時長
      mediaTotalDuration: 0,
      // 媒體時長滑塊
      mediaSlider: 28.5,

      // 媒體-當前進度
      mediaProgressNum: 1,
      // 媒體-總長度
      mediaLengthNum: 12,

      // 媒體操作-顯示狀態
      // mediaShow: false,
      // 媒體播放-暫停
      mediaPlayStatus: false,
      // 媒體播放-停止
      mediaStopStatus: false,
      // 媒體播放-當前時長
      mediaCurrentDuration: 0,
      // 媒體播放-總時長
      mediaTotalDuration: 0,
      // 媒體時長滑塊
      mediaSlider: 0,

      // 媒體音量-顯示狀態
      volumeShow: false,
      // 媒體音量狀態
      volumeStatus: false,
      // 媒體音量滑塊
      volumeSlider: 80,
      // 全屏模式-左側工具欄顯示
      fullLeftShow: false,
      // 全屏模式-底部進度條顯示
      fullBottomShow: false,
      videoBottomShow: false,

      volume: 1, // initial volume
      savedVolume: null, //saved volume
      isMuted: false, // initial mute state
      isPlay: false,
      currentTimeVideo: 0, // initial current time
      duration: 0, // initial duration

      LessonRecordUrl: "",
      TBUrl: "",
      taskIdRecording: "",
      screenEntry: true,

      visibleImage: -1,
      fabricWidth: 0,
      fabricHeight: 0,

      backgroundState: 0,
      searchKey: "",
      currentPage: 0,
      itemsPerPage: 10,
      resultCount: 0,
      theLastLastPage: 0, //for pagination (previous)
      paginationLayers: [],
      currentLayer: 0,

      initialShape: true,
      initialDraw: true,
      currentShape: null,

      // zoomFactor: 0,

      svgUrl: "",
      objectSelected: false,
      previousCurrentTool: "",
      currentSelectedImage: "",

      prevIndexGlobal: 0,
      currentIndexGlobal: 0,
      nextIndexGlobal: 0,
      // msg:'',
      // text: "",
      // empty: true,
      // send:true,
      colorClicked: false,
      versions: 0,
      showAudioSlider: false,
      showLineWidthSlider: false,
      showStamp: false,

      //trtc
      localStream: null,
      roomId: "",
      userId: "",
      userName: "",
      userType: "",
      remoteStream: [],
      sdkAppId: 20001292,
      // sdkAppId: 1400748574,
      client: null,
      is_teacher: false,
      remoteStreamIds: [],
      remoteStreamTIds: [],

      cameras: null,
      microphones: null,
      speakers: null,
      s_camera: "",
      s_mic: "",
      s_speaker: "",

      mediaSelected: "",
      mediaVedioSelected: "",
      mediaVideoNameSelected: "",

      isLoading: false,
      streamTeacher: null,

      streamStudents: [],

      streamStudent: null,

      isWebCamActive: false,
      isAudioActive: false,
      isSpeakerActive: false,

      isWebCamActiveRemote: [],
      isAudioActiveRemote: [],

      // volume: 100,

      timeData: 30,

      input: {
        year: 0,
        month: 0,
        day: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      },

      interval: 1,

      liveChatItems: [],
      isCheckAll: false,

      stateTime: true,
      currentTime: Date.now(),
      intervalTime: null,

      initialHour: 0,
      initialMin: 0,
      initialSec: 0,
      initialMilliSec: 0,

      message: "Let the countdown begin!!",
      totalTime: this.$store.state.classTime * 60,
      timerRunning: false,
      interval: null,

      MaterialMediaObjectData: [],
      MaterialVedioObjectData: [],
      MaterialObjectData: [],

      //CanvasLib part
      canvas: null,
      colorPalette: [
        "#f38181",
        "#c9d6df",
        "#07689f",
        "#95e1d3",
        "#fce38a",
        "#ff2e63",
        "#2b2e4a",
        "#aedefc",
      ],
      drawingData: {
        color: "black",
        x: "",
        y: "",
        lineWidth: 1,
      },
      ctx: null,
      isPainting: false,

      currentTool: "",
      done: false,
      fabricObj: [],
      initIdx: 0,

      mouseFrom: {},
      mouseTo: {},
      moveCount: 1,
      doDrawing: false,
      fabricHistoryJson: [],
      mods: 0,
      drawingObject: null, //Draw Object
      drawColor: "#E34F51",
      drawWidth: 2,
      imageBase64: "",
      zoom: window.zoom ? window.zoom : 1,
      zoomIn: 1,
      zoomOut: 1,
      top: 0,
      left: 0,
      contentSizeHeight: 0,
      contentSizeWidth: 0,
      setColor: [
        "#FF0000",
        "#F2C94C",
        "#EBFF00",
        "#9B51E0",
        "#6FCF97",
        "#F2F2F2",
        "#00FFF0",
        "#33FF00",
        "#00A3FF",
        "#FF00C7",
        "#FF7A00",
        "#0075FF",
      ],

      colorInput: "#E34F51",
      distance: 100,
      // zoomValue: "100%",
      userIdz: "",
      teachername: "",

      MaterialFileType: "",
      MaterialFileName: "",
      MaterialName: "",
      MaterialFileUrl: "",
      MaterialUnitPageId: "",
      MaterialUnit: "",
      MaterialUnitPage: "",
      MaterialCode: "",
      currentBackgroundImage: "",
      loadingMedia: false,

      prevMaterialFileType: "",
      prevMaterialFileName: "",
      prevMaterialName: "",
      prevMaterialFileUrl: "",
      prevMaterialUnitPageId: "",
      prevMaterialUnit: "",
      prevMaterialUnitPage: "",
      prevMaterialCode: "",

      onlineUsers: [],
      formComments: [],
      onlineUsersId: [],
      onlineUsersName: [],

      chatTextSent2: "",
      chatTextSent: "",
      fileUploads: "",
      uuid: uuid.v4(),
      fileUploadsBase64: "",

      // originZoomValue: 0,
      viewportTransform: null,
      borderRange: 1,
      volumeRange: 0.5,
      lastChatItem: 0,

      isJoin: false,
      isSS: false,

      SELECTIMGWIDTH: "",
      SELECTIMGHEIGHT: "",

      clickSaveTeacherComment: true,

      checkingTimer: null,
      nowDateTime: null,
      countdownTimerDisable: true,
      enableTimerEvery10s: true,
      showAlertCheckIn: 0,

      checkTimerData: 0,
      beginTimeStamp: 0,

      socket: {},
      socketLoaded: false,

      isShowVideoModal: false,
      isClickedByMe: false,

      imgTempId: "",
      jsonFileUrl: "",
      fileUrl: "",
      valueToChange: "",
      fileURLName: "",

      canvasWidth: 0,
      canvasHeight: 0,
      imgContainerWidth: 0,
      imgContainerHeight: 0,
      pageFull: false,
      currentIndexMaterial: -1,
      content: [],
      drawFirstState: true,
      loadNewPage: false,
      CleanPage: false,
      newMaterial: [],
      newMaterialState: false,
      sequenceRestoredFromDB: false,
      student_drawing_permissions: false,
      thumbHeight: 100,
      thumbTop: 0,
      isDragging: false,
      dragStartY: 0,
      thumbStartTop: 0,
      startY: null,
      startScrollTop: 0,
      scrollbarHeight: 0,
      thumbLeft: 0,
      thumbWidth: 50,
      scrollbarWidth: 0,
      isDraggingHorizontal: false,
      startX: 0,
      startScrollLeft: 0,
      startThumbLeft: 0,

      audioCtx: null,
      audioBuffer: null,
      sourceNode: null,
      startTime: 0,
      pauseTime: 0,
      elapsedTime: 0,
      audioUrl: null,
      isPlaying: false,
      isPaused: false,
      timeUpdateRAF: null,
      isDraggingSlider: false,
      gainNode: null,
      pendingAudioPlay: false,
    };
  },
  computed: {
    urlForSocket() {
      return `${process.env.VUE_APP_SOCKET_URL}`;
    },
    errorLogs() {
      return this.$store.getters.errorLogs;
    },

    totalPages: function () {
      return Math.ceil(this.resultCount / this.itemsPerPage);
    },
    paginate: function () {
      if (
        !this.MaterialObjectData ||
        this.MaterialObjectData.length != this.MaterialObjectData.length
      ) {
        return;
      }
      this.resultCount = this.MaterialObjectData.length;
      if (this.currentPage >= this.totalPages) {
        this.currentPage = this.totalPages;
      }
      var index = this.currentPage * this.itemsPerPage - this.itemsPerPage;
      return this.MaterialObjectData.slice(index, index + this.itemsPerPage);
    },
    time: function () {
      return this.hours + " : " + this.minutes + " : " + this.seconds;
    },
    milliseconds: function () {
      return this.currentTime;
    },
    hours: function () {
      var milli = this.milliseconds;
      var hrs = Math.floor((this.totalTime / 3600000) % 24);
      return hrs >= 10 ? hrs : "0" + hrs;
      // let h = Math.trunc((this.endDate - this.nowz) / 1000 / 3600);
      // return h>9?h:'0'+h;
    },
    minutes: function () {
      var min = Math.floor(this.totalTime / 60);
      return min >= 10 ? min : "0" + min;
      // let m = Math.trunc((this.endDate - this.nowz) / 1000 / 60) % 60;
      // return m>9?m:'0'+m;
    },
    seconds: function () {
      var sec = this.totalTime - this.minutes * 60;
      return sec >= 10 ? sec : "0" + sec;
      // let s = Math.trunc((this.endDate - this.nowz)/1000) % 60
      // return s>9?s:'0'+s;
    },
    ...mapGetters(["employee_full_status", "UserName", "UserType"]),
  },
  watch: {
    MaterialMediaObjectData: {
      deep: true,
      handler() {
        this.MaterialMediaObjectDataKey++; // Increment the key to force the combo box to update
      },
    },
    MaterialVedioObjectData: {
      deep: true,
      handler() {
        this.MaterialVedioObjectDataKey++; // Increment the key to force the combo box to update
      },
    },
    fileSelectCheck: {
      deep: true,
      handler() {
        // Reset video
        this.mediaCurrentDuration = 0;
        this.currentTimeVideo = 0;  
        if (this.$refs.video) {
          this.$refs.video.currentTime = 0.01;
        }

        // Reset audio
        this.stopAudio(); // clean up sourceNode + stop playback
        this.audioBuffer = null; // clear current buffer (optional)
        this.isPaused = false;
      },
    },
    errorLogs: {
      // handler() {
      //     this.showAlert();
      // },
      deep: true,
    },
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.disconnect();
    }
    if (this._unlockAudio) {
      document.removeEventListener("touchstart", this._unlockAudio);
      document.removeEventListener("click", this._unlockAudio);
    }
  },
  methods: {
    // 媒體文件切換選擇
    fileSelectChange() {
      // 如果音頻有選中的話 那就顯示進度條和音量
      if (this.fileSelectCheck) {
        this.mediaShow = true;
        this.volumeShow = true;

        console.log(this.fileSelectCheck);
        if (this.fileSelectCheck.FileType === "audio/mp3") {
          this.onChangeMedia();
          // this.fileAudioDuration()
        } else {
          this.onChangeVedioMedia();
        }
      }
    },
    // Get Duration
    fileAudioDuration() {
      const audioElement = document.getElementById("main_audio");
      console.log(audioElement);

      audioElement.oncanplaythrough = () => {
        const durationInSeconds = audioElement.duration;
        const formattedDuration = formatDuration(durationInSeconds);
        this.mediaTotalDuration = formattedDuration;
        console.log(durationInSeconds);
        console.log(formattedDuration);
      };
      // console.log(audioElement.duration)

      audioElement.addEventListener("loadedmetadata", () => {
        const durationInSeconds = audioElement.duration;
        const formattedDuration = formatDuration(durationInSeconds);
        this.mediaTotalDuration = formattedDuration;
        console.log(durationInSeconds);
        console.log(formattedDuration);
      });

      function formatDuration(durationInSeconds) {
        const minutes = Math.floor(durationInSeconds / 60);
        const seconds = Math.floor(durationInSeconds % 60);
        return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
      }
    },
    // 媒體播放進度切換
    mediaChange(val) {
      console.log("當前音量：" + val);
    },
    // 媒體聲音切換
    volumeClick() {
      this.volumeStatus = !this.volumeStatus;
      if (this.volumeStatus) {
        this.savedVolume = this.volumeSlider;
        this.$refs.audio.muted = true;
        if (this.gainNode) this.gainNode.gain.value = 0;
      } else {
        this.$refs.audio.muted = false;
        this.volumeSlider = this.savedVolume;
        if (this.gainNode) this.gainNode.gain.value = this.volumeSlider / 100;
      }
    },
    // 媒體音量切換
    volumeChange(val) {
      this.handleVolumeChange();
      if (val == 0) {
        this.volumeStatus = true;
      } else {
        this.volumeStatus = false;
      }
    },
    // 全屏切換
    fullChange() {
      var width = $("#whiteboardContainer").width();
      var height = $("#whiteboardContainer").height();

      this.$store.commit(
        "SET_FULL_STATUS_EMPLOYEE",
        !this.employee_full_status
      );
      if (!this.employee_full_status) {
        $(".employee-box").removeAttr("style");
        $("#router").removeAttr("style");
      } else {
        $(".employee-box").css({ padding: "0px 100px" });
        $("#router").css({ height: "100%", width: "100%" });
      }
      whiteboard.fullscreen(this.isShowVideoModal, width, height);
      this.zoom = 1;
      this.updateThumb();
    },
    // 全屏模式-底部播放欄劃上顯示
    fullBottomMouseover() {
      this.fullBottomShow = true;
    },
    // 全屏模式-底部播放欄劃開隱藏
    fullBottomMouseleave() {
      this.fullBottomShow = false;
    },
    videoMouseOver() {
      this.videoBottomShow = true;
    },
    videoMouseleave() {
      this.videoBottomShow = false;
    },

    async receiveMaterialsBySocket(data) {
      if (this.socketLoaded && !!data) {
        if (data.next) {
          let responseMaterial = await this.$store.dispatch(
            "fetchHitutorMedia",
            {
              ClassroomId: data.ClassroomId,
              LastPage: data.LastPage,
              RequestPages: data.RequestPages,
            }
          );
          console.log("receiveMaterialsBySocket", responseMaterial);
          if (responseMaterial.data.IsSuccess == true) {
            this.theLastLastPage =
              this.MaterialObjectData[0].MaterialUnitPageId;
            //let isAnyMessageProps = Object.hasOwn(responseMaterial.data, "Message");
            let isAnyMessageProps = this.hasProperty(
              responseMaterial.data,
              "Message"
            );

            if (isAnyMessageProps == false || isAnyMessageProps === false) {
              this.MaterialObjectData = responseMaterial.data.MaterialObject;
              this.MaterialVedioObjectData =
                responseMaterial.data.MaterialVedioObject;
              this.MaterialMediaObject =
                responseMaterial.data.MaterialMediaObject;

              if (
                this.MaterialObjectData[0].MaterialUnitPageId !=
                  this.theLastLastPage ||
                this.MaterialObjectData[0].MaterialUnitPageId !==
                  this.theLastLastPage
              ) {
                if (this.paginationLayers.length > 0) {
                  if (this.paginationLayers.includes(this.theLastLastPage)) {
                  } else {
                    this.paginationLayers.push(this.theLastLastPage);
                  }
                } else {
                  this.paginationLayers.push(this.theLastLastPage);
                }
                this.nextIndexGlobal = 1;
                currentIndex = 0;
                prevIndex = -1;
                nextIndex = currentIndex + 1;

                this.currentLayer = this.currentLayer + 1;
                if (this.currentLayer > this.paginationLayers.length - 1) {
                  this.currentLayer = this.paginationLayers.length - 1;
                }
              } else {
                currentIndex = this.MaterialObjectData.length - 1;
                nextIndex = this.MaterialObjectData.length - 1;
                prevIndex = currentIndex - 1;
              }
            } else {
              alert(responseMaterial.data.Message);
              currentIndex = this.MaterialObjectData.length - 1;
              nextIndex = this.MaterialObjectData.length - 1;
              prevIndex = currentIndex - 1;
            }
          } else {
            currentIndex = this.MaterialObjectData.length - 1;
            nextIndex = this.MaterialObjectData.length - 1;
            prevIndex = currentIndex - 1;
          }
        } else {
          let responseMaterial = await this.$store.dispatch(
            "fetchHitutorMedia",
            {
              ClassroomId: data.ClassroomId,
              LastPage: data.LastPage,
              RequestPages: data.RequestPages,
            }
          );

          if (responseMaterial.data.IsSuccess == true) {
            this.MaterialObjectData = responseMaterial.data.MaterialObject;
            this.MaterialVedioObjectData =
              responseMaterial.data.MaterialVedioObject;
            this.MaterialMediaObject =
              responseMaterial.data.MaterialMediaObject;

            this.nextIndexGlobal = this.MaterialObjectData.length;
            currentIndex = this.MaterialObjectData.length - 1;
            prevIndex = currentIndex - 1;
            nextIndex = this.nextIndexGlobal;
            this.currentLayer = this.currentLayer - 1;
          } else {
            currentIndex = 0;
            prevIndex = 0;
            nextIndex = currentIndex + 1;
          }
        }
      }
    },
    initializeSocket() {
      // alert("socket");
      let urlForSocket = this.urlForSocket; // Get the socket URL from your computed property
      this.socket = io(urlForSocket, { secure: true });

      this.socket.on("got-connected", () => {
        this._isFirstImgTempId = true; // 初次加入/刷新後，首次 getImgTempId 用於頁碼核對
        this.socketLoaded = true;
        // Generate room name and create socket.io channel with it
        // alert(String(this.$store.state.classRoomId));
        this.socket.emit("join-room", {
          roomId: String(this.roomId),
          userId: String(this.userId),
          user: String(this.userName),
          userType: this.userType,
        });
      });

      this.socket.on("getUserList", async (data) => {
        console.log("userList", data);
        this.$emit("retrieveUserList", data);
      });

      this.socket.on("getStudentPermissions", (data) => {
        this.student_drawing_permissions = data;
        this.$emit("student_drawing_permissions", data);
      });

      this.socket.on("setStudentPermissions", (data) => {
        console.log("setStudentPermissions", data);
        this.setPermissionsStudent(data);
        if (!data) {
          this.$refs.toolCursorDiv.click();
        }
      });

      this.socket.on("setClockIn", (data) => {
        this.$emit("clockIn", data);
      });

      this.socket.on("setClockOut", (data) => {
        this.$emit("clockOut");
      });

      this.socket.on("setScroll", (data) => {
        const scrollContainer = this.$refs.whiteboardContainer;
        if (!scrollContainer) return;

        const scrollHeight = scrollContainer.scrollHeight;
        const clientHeight = scrollContainer.clientHeight;

        if (scrollHeight <= clientHeight || typeof data.scrollPercentage !== 'number') return;

        const scrollPercentage = Math.min(data.scrollPercentage, 1);
        const scrollTop = scrollPercentage * (scrollHeight - clientHeight);

        scrollContainer.scrollTop = scrollTop;
        const trackHeight = clientHeight; // Or use your actual scrollbar track height if different
        const thumbHeight = (clientHeight / scrollHeight) * trackHeight;
        this.thumbTop = (scrollTop / (scrollHeight - clientHeight)) * (trackHeight - thumbHeight);
      });

      this.socket.on("user-joined", async (data) => {
        var user = data.user;
        this.$emit("retrieveUserList", data.userList);
        if (user) {
          if (user?.userType != "3") {
            this.$toast(
              {
                component: Notification,
                props: {
                  user: `${user.user}`,
                  type: "join",
                },
              },
              {
                position: "top-right",
                timeout: 5000,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true,
                rtl: false,
              }
            );
          }
        }
      });

      this.socket.on("user-exit", async (data) => {
        var user = data.user;
        this.$emit("retrieveUserList", data.userList);
        if (user) {
          if (user.userType != "3") {
            if (user.userType == "1") {
              this.$emit("stopTimerRun");
            }
            this.$toast(
              {
                component: Notification,
                props: {
                  user: `${user.user}`,
                  type: "exit",
                },
              },
              {
                position: "top-right",
                timeout: 5000,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true,
                rtl: false,
              }
            );
          }
        }
      });

      this.socket.on("getCurrentIndexGlobal", async (data) => {
        // console.log("currentData", data[this.roomId])
        this.currentIndexMaterial = data[this.roomId];
        await signaling_socket.emit("getSavedData", whiteboardId);

        if (this.currentIndexMaterial >= 0) {
          if (!this.newMaterialState) {
            var height = $("#backgroundGrid").height();

            $("#frontPage, #previousPage, #nextPage, #lastPage").css({
              "pointer-events": "none",
              cursor: "not-allowed",
            });
            $("#loadingMedia").removeAttr("style");
            $("#loadingMedia").css({
              zIndex: "1",
              height:
                $("#backgroundGrid").height() > $("#whiteboardContainer").height()
                  ? height
                  : "100%",
            });
            // 直接加载对应页面，不依赖 this.content 变化
            this.loadImgMaterial();
            // 安全网：getSavedData 到达后补充绘图数据（只加载笔划，不处理背景图）
            var unwatchContent = this.$watch(
              () => this.content,
              (newContent) => {
                if (newContent && newContent.length > 0) {
                  var strokesOnly = newContent.filter(item => item && item["t"] !== "addImgContentAsBG" && item["t"] !== "clear");
                  if (strokesOnly.length > 0) {
                    // 先清除已加載的 DB JSON 筆跡，避免與 live buffer 重複疊加
                    whiteboard.loadCurrentData([{t: "clearDrawing"}, ...strokesOnly], false);
                  }
                }
                unwatchContent();
              }
            );
          } else {
            this.newMaterialState = false;
            this.mediaProgressNum = this.currentIndexGlobal + 1;
            this.mediaLengthNum = this.mediaLengthNum + this.newMaterial.length;
            const renderedWidth = "1200";
            const renderedHeight = "1500";
            this.setupCanvasAndResizeElements(renderedWidth, renderedHeight);

            // 一次性 watcher：content 到達後立即取消，避免 getCurrentIndexGlobal
            // 多次觸發時累積永久 watcher，導致畫板反覆重繪而閃動
            var unwatchNewMaterial = this.$watch(
              () => this.content,
              () => {
                console.log("contentDataLoadNoMaterial", this.content);
                whiteboard.loadCurrentData(this.content);
                this.pageButtonSet("newPage");
                unwatchNewMaterial();
              }
            );
          }
        } else {
          const renderedWidth = "1200";
          const renderedHeight = "1500";
          this.setupCanvasAndResizeElements(renderedWidth, renderedHeight);
          // 一次性 watcher：避免每次 getCurrentIndexGlobal 新增永久監聽器
          var unwatchInitial = this.$watch(
            () => this.content,
            () => {
              console.log("contentDataLoadNoMaterial", this.content);
              whiteboard.loadCurrentData(this.content);
              unwatchInitial();
            }
          );
          // 默认加载第一页（与教师端 pageChange("nextPage") 对应）
          if (this.MaterialObjectData && this.MaterialObjectData.length > 0) {
            this.currentIndexMaterial = 0;
            this.loadImgMaterial();
          }
        }
      });

      this.socket.on("getNewMaterial", (data) => {
        // 若序列已從 DB 還原（含插入頁），跳過此處的 splice，避免重複插入
        if (this.sequenceRestoredFromDB) return;
        if (data.length > 0) {
          var newMaterialIndex = new Map();
          for (let i = 0; i < data.length; i++) {
            this.newMaterial.push(data[i].newMaterial);
            this.MaterialObjectData.splice(
              data[i].currentIndexGlobal,
              0,
              data[i].newMaterial
            );
            newMaterialIndex.set(data[i].currentIndexGlobal, i);
          }
          this.currentIndexGlobal = data[data.length - 1].currentIndexGlobal;
          this.$watch(
            () => this.currentIndexMaterial,
            () => {
              console.log(
                "NewMaterial",
                this.MaterialObjectData,
                this.currentIndexGlobal,
                this.currentIndexMaterial
              );
              if (newMaterialIndex.has(this.currentIndexMaterial)) {
                this.newMaterialState = true;
              } else {
                this.newMaterialState = false;
              }
              this.mediaProgressNum = this.currentIndexMaterial + 1;
              this.mediaLengthNum = this.mediaLengthNum + data.length - 1;
            }
          );
        }
      });

      this.socket.on("getLoadJsonFromDatabase", (data) => {
        console.log("loadJsonFromDatabase Socket Client", data);
        this.loadJsonFromDatabaseClient(
          data.roomId,
          data.englishName,
          data.materialUnit,
          data.materialPage,
          data.type,
          false
        );
      });

      this.socket.on("updateIndexGlobal", (data) => {
        // console.log("test-socket", data)
        this.prevIndexGlobal = data.prevIndexGlobal;
        this.nextIndexGlobal = data.nextIndexGlobal;
        this.currentIndexGlobal = data.currentIndexGlobal;
      });

      this.socket.on("getImgTempId", (data) => {
        var height = $("#backgroundGrid").height();

        $("#frontPage, #previousPage, #nextPage, #lastPage").css({
          "pointer-events": "none",
          cursor: "not-allowed",
        });
        $("#loadingMedia").removeAttr("style");
        $("#loadingMedia").css({
          zIndex: "1",
          height:
            $("#backgroundGrid").height() > $("#whiteboardContainer").height()
              ? height
              : "100%",
        });

        this.prevIndexGlobal = data.num[0];
        this.nextIndexGlobal = data.num[1];
        this.currentIndexGlobal = data.num[2];
        this.mediaProgressNum = data.num[3];

        if (typeof data.file === "string") {
          var paramFileNameList = data.file.split("|");
          this.MaterialUnit = paramFileNameList[2];
          this.MaterialUnitPage = paramFileNameList[3];
          this.MaterialFileName = paramFileNameList[4];
          this.EnglishFileName = paramFileNameList[4];
          this.ChineseFileName = paramFileNameList[4];
          this.MaterialName = paramFileNameList[5];
        } else {
          this.MaterialUnit = data.file.materialUnit;
          this.MaterialUnitPage = data.file.materialPage;
          this.MaterialFileName = data.file.fileName;
          this.EnglishFileName = data.file.englishName;
          this.ChineseFileName = data.file.chineseName;
          this.MaterialName = data.file.materialName;
        }

        // 安全網：初次收到 getImgTempId 時，若頁碼與 getCurrentIndexGlobal 不一致，重新載入正確頁面
        if (this._isFirstImgTempId) {
          this._isFirstImgTempId = false;
          if (data.num[2] >= 0 && this.currentIndexMaterial >= 0 && data.num[2] !== this.currentIndexMaterial) {
            console.warn("[安全網] getImgTempId 頁碼與 getCurrentIndexGlobal 不符，修正為", data.num[2]);
            this.currentIndexMaterial = data.num[2];
            if (signaling_socket) signaling_socket.emit("getSavedData", whiteboardId);
            this.loadImgMaterial();
            // 等待 getSavedData 回應後補充正確頁面的筆跡
            var unwatchSafetyContent = this.$watch(
              () => this.content,
              (newContent) => {
                if (newContent && newContent.length > 0) {
                  var safetyStrokes = newContent.filter(item => item && item["t"] !== "addImgContentAsBG" && item["t"] !== "clear");
                  if (safetyStrokes.length > 0) {
                    whiteboard.loadCurrentData([{t: "clearDrawing"}, ...safetyStrokes], false);
                  }
                }
                unwatchSafetyContent();
              }
            );
          }
        }
      });

      this.socket.on("updateNewMaterial", (data) => {
        if (this.sequenceRestoredFromDB) return;
        this.MaterialObjectData.splice(
          this.mediaProgressNum - 1,
          0,
          data.newMaterial
        );
        this.prevIndexGlobal = data.prevIndexGlobal;
        this.nextIndexGlobal = data.nextIndexGlobal;
        this.currentIndexGlobal = data.currentIndexGlobal;
        this.mediaProgressNum = this.nextIndexGlobal;
        this.mediaLengthNum = this.mediaLengthNum + 1;

        const renderedWidth = "100%";
        const renderedHeight = "100%";
        $("#whiteboardCanvas").css({
          width: renderedWidth,
          height: renderedHeight,
        });
        this.setupCanvasAndResizeElements(renderedWidth, renderedHeight);
      });

      this.socket.on("audioCurrentTime", (data) => {
        // console.log("socket", data);
        this.$refs.audio.currentTime = data;
      });

      this.socket.on("initialAudio", async (data) => {
        if (!data) {
          return;
        }

        if (data["isShowVideoModal"]) {
          let { selectedMedia } = data;
          this.isShowVideoModal = data.isShowVideoModal;
          if (this.isShowVideoModal) {
            this.mediaVedioSelected = selectedMedia.FileUrl;
            this.mediaVideoNameSelected = selectedMedia.FileName;
            this.fileSelectCheck = selectedMedia;
            whiteboard.isVideoShow = this.isShowVideoModal;
            this.adjustVideoElementSize();
          } else {
            this.isPlay = false;
            this.$refs.video.pause();
          }

          const video = this.$refs.video;
          setTimeout(() => {
            video.currentTime = 0.01;
            video.currentTime = data.time;
            this.currentTimeVideo = data.time;
            if (data.action == "play") {
              this.isPlay = true;
              this.$refs.video.play().catch(() => {});
            }
          }, 100);
        } else {
          try {
            let { selectedMedia } = data;
            this.mediaSelected = selectedMedia.FileUrl;
            this.fileSelectCheck = selectedMedia;

            // 關閉舊的 AudioContext，並重置 gainNode，防止新 sourceNode 連接到舊節點導致無聲
            if (this.audioCtx) {
              this.audioCtx.close().catch(() => {});
            }
            this.gainNode = null;
            this.audioCtx = new (window.AudioContext ||
              window.webkitAudioContext)();

            const response = await fetch(this.mediaSelected);
            const arrayBuffer = await response.arrayBuffer();
            this.audioBuffer = await this.audioCtx.decodeAudioData(arrayBuffer);

            this.mediaTotalDuration = this.audioBuffer.duration;
            this.mediaCurrentDuration = data.time;
            if (data.time != 0) this.isPaused = true;

            this.handleAudioControl(data.action);
          } catch (err) {
            console.error("Error loading or decoding audio:", err);
          }
        }
      });

      this.socket.on("updateAudioTime", async (data) => {
        if (data && typeof data.time === "number" && this.mediaPlayStatus) {
          this.handleTimeUpdate(data.time);
        }

        // 僅在播放中才做 drift 校正，避免停止後被意外觸發播放
        if (!this.mediaPlayStatus) return;
        if (!this.audioCtx || !this.startTime) return;
        const localElapsed = this.audioCtx.currentTime - this.startTime;
        const drift = Math.abs(localElapsed - data.time);

        // 只在时间差超过 2 秒时才重建音频源，避免频繁重建导致 iPad 音频卡顿
        if (drift > 2) {
          if (this.sourceNode) {
            this.sourceNode.onended = null;
            this.sourceNode.stop();
            this.sourceNode.disconnect();
            this.sourceNode = null;
          }

          this.createSource(data.time);
        }
      });

      this.socket.on("toggle-audio-playback", (data) => {
        if (data.action === "play" && !this.audioBuffer) {
          this.pendingAudioPlay = true;
          return;
        }
        if (data.action !== "play") {
          this.pendingAudioPlay = false;
        }
        this.handleAudioControl(data.action);
      });

      this.socket.on("send-background-index", (data) => {
        this.receiveCurrentIndex(data);
      });

      this.socket.on("send-material-lists", (data) => {
        this.receiveMaterialsBySocket(data);
      });

      this.socket.on("send-material-video-media", (data) => {
        let { selectedVideoMedia } = data;
        console.log(selectedVideoMedia);
        let existingMediaIndex = this.MaterialVedioObjectData.findIndex(
          (media) => media.FileUrl === selectedVideoMedia.FileUrl
        );

        if (existingMediaIndex !== -1) {
          this.$set(
            this.MaterialVedioObjectData,
            existingMediaIndex,
            selectedVideoMedia
          );
        } else {
          this.MaterialVedioObjectData.push(selectedVideoMedia);
        }

        this.mediaVedioSelected = selectedVideoMedia.FileUrl;
        this.fileSelectCheck = selectedVideoMedia;
        this.mediaShow = !this.mediaShow;
      });

      // 接收教師端全屏同步
      this.socket.on("toggle-fullscreen", (data) => {
        if (data.isFull !== this.employee_full_status) {
          this.fullChange();
        }
      });

      // 接收教師端縮放同步
      this.socket.on("sync-zoom", (data) => {
        const delta = data.zoom - this.zoom;
        if (Math.abs(delta) > 0.001) {
          this.setZoom(delta);
        }
      });

      this.socket.on("show-video-modal", (data) => {
        this.isShowVideoModal = data.isShowVideoModal;
        whiteboard.isVideoShow = this.isShowVideoModal;

        if (this.isShowVideoModal) {
          if (this.mediaVedioSelected != data.mediaVideoSelected.FileUrl) {
            this.mediaVedioSelected = data.mediaVideoSelected.FileUrl;
            this.mediaVideoNameSelected = data.mediaVideoSelected.FileName;
            this.fileSelectCheck = data.mediaVideoSelected;

            const video = this.$refs.video;
            setTimeout(() => {
              video.currentTime = 0.01;
            }, 100);
          }
          this.adjustVideoElementSize();
        }
      });

      this.socket.on("playVideo", () => {
        this.setupVideoAudioRouting();
        this.$refs.video.play().then(() => {
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
                        (navigator.maxTouchPoints > 1 && /Mac/.test(navigator.userAgent));
          if (isIOS || (this.$refs.video && this.$refs.video.muted && !this.isMuted)) {
            this.$message({ message: "請點擊視頻畫面以啟用聲音", type: "info", duration: 5000 });
          }
        }).catch(() => {
          this.$message({ message: "請點擊視頻畫面以開始播放", type: "info", duration: 5000 });
        });
      });
      this.socket.on("pauseVideo", () => {
        this.$refs.video.pause();
      });

      this.socket.on("changeVolume", (volume) => {
        this.volume = volume;
        this.$refs.video.volume = this.volume;
      });

      this.socket.on("toggleMute", (isMuted) => {
        this.isMuted = isMuted;
        this.$refs.video.muted = this.isMuted;
      });
      this.socket.on("changeCurrentTime", (currentTime) => {
        this.currentTimeVideo = currentTime;
        this.$refs.video.currentTime = this.currentTimeVideo;
      });

      this.socket.on("videoCurrentTime", (data) => {
        if (!data) {
          return;
        }

        if (data["isShowVideoModal"] && !this.isShowVideoModal) {
          let { selectedMedia } = data;
          this.isShowVideoModal = data.isShowVideoModal;
          if (this.isShowVideoModal) {
            this.mediaVedioSelected = selectedMedia.FileUrl;
            this.mediaVideoNameSelected = selectedMedia.FileName;
            this.fileSelectCheck = selectedMedia;
            whiteboard.isVideoShow = this.isShowVideoModal;
            this.adjustVideoElementSize();
          } else {
            this.isPlay = false;
            this.$refs.video.pause();
          }

          const video = this.$refs.video;
          setTimeout(() => {
            video.currentTime = 0.01;
            video.currentTime = data.time;
            this.currentTimeVideo = data.time;
            if (data.action == "play") {
              this.isPlay = true;
              this.$refs.video.play().catch(() => {});
            }
          }, 100);
        } else if (data["isShowVideoModal"] && this.isShowVideoModal) {
          if (data["action"] === "play" && this.$refs.video.paused) {
            this.isPlay = true;
            this.$refs.video.play().catch(() => {});
          } else if (data["action"] === "pause" && !this.$refs.video.paused) {
            this.isPlay = false;
            this.$refs.video.pause();
          }

          this.currentTimeVideo = data["time"];
          // 只在时间差超过 2 秒时才 seek，避免频繁 seek 导致 iPad 音频卡顿
          var timeDiff = Math.abs(this.$refs.video.currentTime - data["time"]);
          if (timeDiff > 2) {
            this.$refs.video.currentTime = data["time"];
          }
        }
      });

      this.socket.on("videoDuration", (duration) => {
        this.duration = duration;
        console.log(duration);
      });

      this.socket.on("sync-media", (data) => {
        if (!data) return;

        // Ignore own updates (if student is also teacher in some cases)
        if (data.sender === this.socket.id) return;

        const isVideo = data.isShowVideoModal;
        const element = isVideo ? this.$refs.video : null;

        // Check if we are playing the same media
        if (
          !this.fileSelectCheck ||
          this.fileSelectCheck.FileUrl !== data.selectedMedia.FileUrl
        ) {
          this.fileSelectCheck = data.selectedMedia;

          if (isVideo) {
            this.mediaVedioSelected = data.selectedMedia.FileUrl;
            this.mediaVideoNameSelected = data.selectedMedia.FileName;
            this.adjustVideoElementSize();
          } else {
            this.mediaSelected = data.selectedMedia.FileUrl;
          }
        }

        // Compare times
        const targetTime = data.time;
        const currentTime = isVideo
          ? element?.currentTime || 0
          : this.mediaCurrentDuration || 0;

        const timeDiff = Math.abs(currentTime - targetTime);

        // 2 秒阈值避免频繁 seek/重建音频源导致 iPad 卡顿
        var syncThreshold = 2;
        if (timeDiff > syncThreshold) {
          if (isVideo && element) {
            element.currentTime = targetTime;
          } else {
            this.mediaCurrentDuration = targetTime;
            // For audio context, you'd restart from targetTime if needed
          }
        }

        // Compare actions (play/pause/stop)
        if (data.action === "play") {
          if (isVideo && element?.paused) {
            element.play().catch(() => {});
          } else if (!isVideo && this.isPaused) {
            this.playAudio(targetTime);
          }
        } else if (data.action === "pause") {
          if (isVideo && !element?.paused) {
            element.pause();
          } else if (!isVideo && !this.isPaused) {
            this.pauseAudio();
          }
        } else if (data.action === "stop") {
          if (isVideo && element) {
            element.pause();
            element.currentTime = 0;
          } else {
            this.stopAudio();
          }
        }
      });

      this.socket.on("send-material-media", (data) => {
        let { selectedMedia } = data;

        // Update MaterialMediaObjectData with the new data
        let existingMediaIndex = this.MaterialMediaObjectData.findIndex(
          (media) => media.FileUrl === selectedMedia.FileUrl
        );

        if (existingMediaIndex !== -1) {
          this.$set(
            this.MaterialMediaObjectData,
            existingMediaIndex,
            selectedMedia
          );
        } else {
          this.MaterialMediaObjectData.push(selectedMedia);
        }

        // Update mediaSelected
        this.mediaSelected = selectedMedia.FileUrl;
        this.fileSelectCheck = selectedMedia;
        this.mediaShow = true;
        this.volumeShow = true;

        const audio = new Audio();
        audio.src = this.mediaSelected;
        this.audioUrl = this.mediaSelected;
        this.loadAudioBuffer();
        audio.addEventListener("loadedmetadata", () => {
          this.mediaTotalDuration = audio.duration;
        });
      });
      this.socket.on("retrieveChats", (data) => {
        console.log("retrieveChats");
        this.$emit("retrieveChats");
      });
      this.socket.on("push-chat-message", (msg) => {
        this.$emit("newChatMessage", msg);
      });
      this.socket.on("setStudentPermissions", (data) => {
        // console.log("setStudentPermissions", data);
        // this.setPermissionsStudent(data);
        // if (!data) {
        //   this.$refs.toolCursorDiv.click();
        // }
      });
    },

    setupCanvasAndResizeElements(width, height) {
      $("#whiteboardCanvas").ready(() => {
        const canvas = document.getElementById("whiteboardCanvas");
        const WHITEBOARD_MIN_WIDTH = 1200;
        var widthContainer = $("#whiteboardContainer").width();
        var heightContainer = $("#whiteboardContainer").height();
        const effectiveWidth = Math.max(widthContainer, WHITEBOARD_MIN_WIDTH);

        // 設定 whiteboardInner 固定像素尺寸，使 overflow:auto 容器能正確顯示捲動條
        $("#whiteboardInner").css({ width: effectiveWidth + "px", height: heightContainer + "px" });
        canvas.width = effectiveWidth;
        canvas.height = heightContainer;
        // 明確設定 canvas CSS 像素尺寸，避免 "100%" 導致內容被壓縮變形
        $(canvas).css({ width: effectiveWidth + "px", height: heightContainer + "px" });

        const elementsToResize = [
          "#textContainer",
          "#mouseOverlay",
          "#imgContainer",
          "#backgroundGrid",
          "#svgContainer",
          "#dropIndicator",
          "#cursorContainer",
          "#loadingMedia",
        ];
        elementsToResize.forEach((element) =>
          $(element).css({ width: effectiveWidth + "px", height: heightContainer + "px" })
        );
      });
    },

    adjustVideoElementSize() {
      var popupVideoElement = document.getElementById("hi_popup_video");
      var whiteboardContainer = document.getElementById("whiteboardContainer");

      popupVideoElement.style.cssText = `
        display: flex;
        flex-direction: column;
        position: absolute;
        z-index: 9999;
        width: ${whiteboardContainer.clientWidth}px;
        height: ${whiteboardContainer.clientHeight}px;
        top: ${
          whiteboardContainer.getBoundingClientRect().top + window.scrollY
        }px;
        left: ${whiteboardContainer.getBoundingClientRect().left}px;
      `;
    },

    // Video Audio Method
    handleVolumeChange() {
      if (this._remoteVolumeUpdate) return;
      if (this.gainNode) {
        this.gainNode.gain.value = this.volumeSlider / 100;
      }

      this.$refs.audio.volume = this.volumeSlider / 100;
    },

    setupSlider() {
      let timeSlider = $(".mejs__time-slider");
      console.log(timeSlider);
      if (timeSlider.length) {
        timeSlider.on("mouseup", (e) => {
          this.userInitiatedUpdate = true;
        });
      }
    },

    handleSliderMouseUp() {
      this.userInitiatedUpdate = true;
      const currentValue = this.currentTime;
    },

    inputTimeUpdate() {
      const seekTime = (this.mediaSlider / 100) * this.$refs.audio.duration;
      this.$refs.audio.currentTime = seekTime;
    },

    formatTime(timeInSeconds) {
      if (!timeInSeconds || isNaN(timeInSeconds) || !isFinite(timeInSeconds) || timeInSeconds < 0) {
        return "00:00:00";
      }
      let hours = Math.floor(timeInSeconds / 3600);
      let minutes = Math.floor((timeInSeconds % 3600) / 60);
      let seconds = Math.floor(timeInSeconds % 60);

      let hoursDisplay = `${hours < 10 ? "0" : ""}${hours}:`;
      let minutesDisplay = `${minutes < 10 ? "0" : ""}${minutes}:`;
      let secondsDisplay = `${seconds < 10 ? "0" : ""}${seconds}`;

      return hoursDisplay + minutesDisplay + secondsDisplay;
    },

    updateCurrentTimeVideoMethod() {
      this.currentTimeVideo = this.$refs.video.currentTime;
    },

    setDuration() {
      this.duration = this.$refs.video.duration;
    },

    playVideo() {
      this.$refs.video.play().catch(() => {});
    },
    pauseVideo() {
      this.$refs.video.pause();
    },

    setupVideoAudioRouting() {
      if (this.$refs.video) {
        this.$refs.video.volume = Math.max(0, Math.min(1, this.volume));
      }
    },
    changeVolume() {
      this.$refs.video.volume = this.volume;
    },
    toggleMute() {
      this.isMuted = !this.isMuted;
      this.$refs.video.muted = this.isMuted;
    },
    changeCurrentTime() {
      this.$refs.video.currentTime = this.currentTimeVideo;
    },
    // 用戶點擊視頻畫面：在手勢上下文中清除瀏覽器強制靜音並確保有聲播放
    onVideoTapUnlock() {
      const video = this.$refs.video;
      if (!video) return;
      if (this.isMuted) return;
      video.muted = false;
      video.volume = Math.max(0, Math.min(1, this.volume));
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        // iOS 僅設置 muted=false 不足以解鎖音頻，必須在手勢上下文中重新調用 play()
        video.pause();
        video.play().catch(() => {});
      }
    },

    startDrag() {
      this.dragging = true;
    },
    stopDrag() {
      this.dragging = false;
    },
    showVideoDialogSocket() {
      this.isShowVideoModal = true;
      let selectedVideoMedia = this.MaterialVedioObjectData.find(
        (media) => media.FileUrl === this.fileSelectCheck.FileUrl
      );
      whiteboard.isVideoShow = this.isShowVideoModal;
      this.adjustVideoElementSize();
    },
    closeVideoDialogSocket() {
      this.isShowVideoModal = false;
      whiteboard.isVideoShow = this.isShowVideoModal;
      this.$refs.video.pause();
    },
    updateAudioTime(newTime) {
      let audioElement = document.getElementById("main_audio");
      audioElement.currentTime = newTime;
      audioElement.play().catch(() => {});
    },
    async loadAudioBuffer() {
      if (this.audioCtx) {
        this.audioCtx.close().catch(() => {});
      }
      this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();

      this.gainNode = this.audioCtx.createGain();
      this.gainNode.gain.value = this.volumeSlider / 100; // set initial volume
      this.gainNode.connect(this.audioCtx.destination);

      const response = await fetch(this.audioUrl);
      const arrayBuffer = await response.arrayBuffer();
      this.audioBuffer = await this.audioCtx.decodeAudioData(arrayBuffer);
      this.mediaTotalDuration = this.audioBuffer.duration;

      if (this.pendingAudioPlay) {
        this.pendingAudioPlay = false;
        await this.playAudio(0);
      }
    },

    createSource(offset = 0) {
      if (this.sourceNode) {
        this.sourceNode.disconnect();
        this.sourceNode.onended = null;
      }

      if (!this.gainNode) {
        this.gainNode = this.audioCtx.createGain();
        this.gainNode.gain.value = this.volumeSlider / 100;
        this.gainNode.connect(this.audioCtx.destination);
      }

      this.sourceNode = this.audioCtx.createBufferSource();
      this.sourceNode.buffer = this.audioBuffer;
      this.sourceNode.connect(this.gainNode);

      this.sourceNode.onended = () => {
        if (!this.isPaused) {
          if (this.mediaCurrentDuration == 0) {
            this.mediaCurrentDuration = 0;
            this.mediaSlider = 0;
          } else if (
            this.mediaCurrentDuration != 0 &&
            this.mediaTotalDuration - this.mediaCurrentDuration < 0.05
          ) {
            this.mediaCurrentDuration = 0;
            this.mediaSlider = 0;
          }

          this.mediaPlayStatus = false;
          this.mediaStopStatus = false;
          this.isPaused = false;
        }
        if (this.sourceNode) {
          this.sourceNode.disconnect();
          this.sourceNode = null;
        }
      };

      this.startTime = this.audioCtx.currentTime - offset;
      this.sourceNode.start(0, offset);
      this.updatePlaybackTime();
    },
    async playAudio(offset = 0) {
      // 靜音麥克風，避免揚聲器音頻被麥克風採集後透過 Agora 產生回音
      this.$emit("audioPlayStart");
      // iOS/iPad 上 AudioContext 可能處於 suspended 狀態，需先 resume 才能播放
      if (this.audioCtx && this.audioCtx.state === "suspended") {
        await this.audioCtx.resume().catch(() => {});
      }
      // 若 AudioContext 仍未解鎖（iOS autoplay 限制），提示用戶點擊畫面
      if (this.audioCtx && this.audioCtx.state !== "running") {
        this.$message({
          message: "請點擊螢幕任意位置以啟用音頻播放",
          type: "info",
          duration: 5000,
        });
      }
      this.createSource(offset);

      this.mediaPlayStatus = true;
      this.mediaStopStatus = true;
      this.isPaused = false;
    },
    pauseAudio() {
      if (!this.sourceNode) return;

      this.sourceNode.stop();
      this.pauseTime = this.audioCtx.currentTime;
      this.mediaCurrentDuration = this.pauseTime - this.startTime;
      this.mediaPlayStatus = false;
      this.isPaused = true;
      this.$emit("audioPlayStop");
    },
    stopAudio() {
      if (this.sourceNode) {
        this.sourceNode.disconnect();
        this.sourceNode.stop();
        this.sourceNode = null;
      }
      this.mediaPlayStatus = false;
      this.mediaStopStatus = false;
      this.isPaused = false;
      this.mediaCurrentDuration = 0;
      cancelAnimationFrame(this.timeUpdateRAF);
      this.$emit("audioPlayStop");
    },
    onAudioPlay() {
      if (this.isPaused) {
        this.playAudio(this.mediaCurrentDuration);
      } else {
        this.playAudio(0);
      }
    },
    onAudioPause() {
      this.pauseAudio();
    },
    onAudioStop() {
      this.stopAudio();
    },
    handleAudioControl(action) {
      if (action === "play") {
        if (this.isPaused) {
          this.playAudio(this.mediaCurrentDuration);
        } else {
          this.playAudio(0);
        }
      } else if (action === "pause") {
        this.pauseAudio();
      } else if (action === "stop") {
        this.stopAudio();
      }
    },

    updatePlaybackTime() {
      // 取消舊的 RAF 循環，防止多個循環並行導致 currentTime 計算混亂
      cancelAnimationFrame(this.timeUpdateRAF);
      const update = () => {
        if (this.sourceNode && this.mediaPlayStatus) {
          const currentTime = this.audioCtx.currentTime - this.startTime;
          this.handleTimeUpdate(currentTime);
          this.timeUpdateRAF = requestAnimationFrame(update);
        }
      };
      this.timeUpdateRAF = requestAnimationFrame(update);
    },

    handleTimeUpdate(currentTime) {
      if (typeof currentTime !== "number") currentTime = 0;

      this.mediaCurrentDuration = currentTime;
      this.mediaSlider = (currentTime / this.mediaTotalDuration) * 100;
    },
    getMaterialMediaObjectData() {
      // alert(this.$store.state.MaterialMediaObject)
      if (this.$store.state.MaterialMediaObject.length > 0) {
        this.MaterialMediaObjectData = JSON.parse(
          JSON.stringify(this.$store.state.MaterialMediaObject)
        );
        console.log(this.MaterialMediaObjectData);
        this.fileSelectList[0].list = this.MaterialMediaObjectData;
      } else {
      }
    },

    getMaterialVedioObjectData() {
      if (this.$store.state.MaterialVedioObject.length > 0) {
        this.MaterialVedioObjectData = JSON.parse(
          JSON.stringify(this.$store.state.MaterialVedioObject)
        );
        this.fileSelectList[1].list = this.MaterialVedioObjectData;
      }
    },

    getMaterialObjectData() {
      if (this.$store.state.MaterialObject.length > 0) {
        if (this.$store.state.MaterialObject.length > 10) {
          let limit = 10;
          this.MaterialObjectData = this.$store.state.MaterialObject.slice(
            0,
            limit
          );
          this.mediaLengthNum = this.MaterialObjectData.length;
        } else {
          this.MaterialObjectData = this.$store.state.MaterialObject;
          this.mediaLengthNum = this.MaterialObjectData.length;
        }

        // 先樂觀設為 true，防止 getNewMaterial 在 GET 回應前觸發的 race condition
        this.sequenceRestoredFromDB = true;
        this.$axios.get(`/materialmodel/sequence/${this.roomId}`)
          .then((res) => {
            if (!res.data.error && res.data.payload && res.data.payload.length > 0) {
              this.MaterialObjectData = res.data.payload;
              this.mediaLengthNum = res.data.payload.length;
            } else {
              this.sequenceRestoredFromDB = false;
            }
            if (process.env.VUE_APP_RUN_STATE == "local") {
              console.log("MaterialObjectData", this.MaterialObjectData);
            }
          })
          .catch(() => {
            this.sequenceRestoredFromDB = false;
          });
      }
      console.log("MaterialObjectData", this.MaterialObjectData);
    },

    loadData() {
      this.initialMilliSec = this.milliseconds;
      this.initialHour = new Date().getHours();
      this.getMaterialMediaObjectData();
      this.getMaterialVedioObjectData();
      this.getMaterialObjectData();
    },

    //----------Whiteboard------------//
    //whiteboard
    handleTools(toolsname, idx) {
      switch (toolsname) {
        case "stamp":
          // this.doDrawing = true
          this.showStamp = !this.showStamp;
          break;
        default:
          break;
      }
    },
    showBasicAlert(html, newOptions) {
      var options = {
        header: "INFO MESSAGE",
        okBtnText: "Ok",
        headercolor: "#d25d5d",
        hideAfter: false,
        onOkClick: false,
      };
      if (newOptions) {
        for (var i in newOptions) {
          options[i] = newOptions[i];
        }
      }
      var alertHtml = $(
        '<div class="basicalert" style="position:absolute; left:0px; width:100%; top:70px; font-family: monospace;">' +
          '<div style="width: 30%; margin: auto; background: #aaaaaa; border-radius: 5px; font-size: 1.2em; border: 1px solid gray;">' +
          '<div style="border-bottom: 1px solid #676767; background: ' +
          options["headercolor"] +
          '; padding-left: 5px; font-size: 0.8em;">' +
          options["header"] +
          '<div style="float: right; margin-right: 4px; color: #373737; cursor: pointer;" class="closeAlert">x</div></div>' +
          '<div style="padding: 10px;" class="htmlcontent"></div>' +
          '<div style="height: 20px; padding: 10px;"><button class="modalBtn okbtn" style="float: right;">' +
          options["okBtnText"] +
          "</button></div>" +
          "</div>" +
          "</div>"
      );
      alertHtml.find(".htmlcontent").append(html);
      $("body").append(alertHtml);
      alertHtml
        .find(".okbtn")
        .off("click")
        .click(function () {
          if (options.onOkClick) {
            options.onOkClick();
          }
          alertHtml.remove();
        });
      alertHtml
        .find(".closeAlert")
        .off("click")
        .click(function () {
          alertHtml.remove();
        });

      if (options.hideAfter) {
        setTimeout(function () {
          alertHtml.find(".okbtn").click();
        }, 1000 * options.hideAfter);
      }
    },
    initWhiteBoard() {
      ReadOnlyService.activateReadOnlyMode();

      if (urlParams.get("webdav") === "true") {
        $("#uploadWebDavBtn").show();
      }

      whiteboard.loadWhiteboard("#whiteboardContainer", {
        //Load the whiteboard
        whiteboardId: whiteboardId,
        username: btoa(encodeURIComponent(this.myUsername)),
        backgroundGridUrl: "./images/" + ConfigService.backgroundGridImage,
        sendFunction: (content) => {
          if (ReadOnlyService.readOnlyActive) return;
          //ADD IN LATER THROUGH CONFIG
          // if (content.t === 'cursor') {
          //     if (whiteboard.drawFlag) return;
          // }
          content["at"] = this.accessToken;
          signaling_socket.emit("drawToWhiteboard", content);
          InfoService.incrementNbMessagesSent();
        },
      });

      // 員工端不從 HTTP /api/loadwhiteboard 載入舊資料，
      // 內容統一由 getCurrentIndexGlobal → loadImgMaterial() 和 getSavedData socket 事件同步，
      // 避免 HTTP 回應晚到時覆蓋已正確載入的畫面造成 race condition

      $(window).resize(function () {
        signaling_socket.emit("updateScreenResolution", {
          at: this.accessToken,
          windowWidthHeight: { w: $(window).width(), h: $(window).height() },
        });
      });

      $("#whiteboardUnlockBtn").hide();
      $("#whiteboardLockBtn").show();

      if (!localStorage.getItem("savedColors")) {
        localStorage.setItem(
          "savedColors",
          JSON.stringify([
            "rgba(0, 0, 0, 1)",
            "rgba(255, 255, 255, 1)",
            "rgba(255, 0, 0, 1)",
            "rgba(0, 255, 0, 1)",
            "rgba(0, 0, 255, 1)",
            "rgba(255, 255, 0, 1)",
            "rgba(255, 0, 255, 1)",
          ])
        );
      }

      this.intColorPicker();
      this.intBgColorPicker();

      // on startup select mouse
      shortcutFunctions.setTool_mouse();
      // fix bug cursor not showing up
      whiteboard.refreshCursorAppearance();

      if (process.env.NODE_ENV === "production") {
        if (ConfigService.readOnlyOnWhiteboardLoad)
          ReadOnlyService.activateReadOnlyMode();
        else ReadOnlyService.deactivateReadOnlyMode();

        // if (ConfigService.displayInfoOnWhiteboardLoad)
        // InfoService.displayInfo();
        // else InfoService.hideInfo();
      } else {
        // in dev
        ReadOnlyService.deactivateReadOnlyMode();
        // InfoService.displayInfo();
      }

      // In any case, if we are on read-only whiteboard we activate read-only mode
      if (ConfigService.isReadOnly) ReadOnlyService.activateReadOnlyMode();
    },
    whiteboardTrashBtn(e) {
      $("#whiteboardTrashBtnConfirm").show().focus();
      $(e.currentTarget).hide();
    },
    whiteboardTrashBtnConfirm(e) {
      $(e.currentTarget).hide();
      $("#whiteboardTrashBtn").show();
      whiteboard.clearWhiteboard();
    },
    whiteboardTrashBtnConfirmHide(e) {
      $(e.currentTarget).hide();
      $("#whiteboardTrashBtn").show();
    },
    whiteboardLockBtn() {
      ReadOnlyService.deactivateReadOnlyMode();
    },
    whiteboardUnlockBtn() {
      ReadOnlyService.activateReadOnlyMode();
    },
    whiteboardSwitch(e) {
      // $(".whiteboard-tool").removeClass("active");
      // $(e.currentTarget).addClass("active");
      console.log(e);
      var activeTool = $(e.currentTarget).attr("tool");
      whiteboard.setTool(activeTool);
      if (activeTool == "mouse" || activeTool == "recSelect") {
        $(".activeToolIcon").empty();
      } else {
        $(".activeToolIcon").html($(e.currentTarget).html()); //Set Active icon the same as the button icon
      }

      if (activeTool == "stamp") {
        this.showStamp = !this.showStamp;
      }

      if (activeTool == "text" || activeTool == "stickynote") {
        $("#textboxBackgroundColorPickerBtn").show();
      } else {
        $("#textboxBackgroundColorPickerBtn").hide();
      }
      let savedThickness = localStorage.getItem("item_thickness_" + activeTool);
      if (savedThickness) {
        whiteboard.setStrokeThickness(savedThickness);
        $("#whiteboardThicknessSlider").val(savedThickness);
      }
    },
    showOnOffMenuStamps(e) {
      this.showStamp = !this.showStamp;
      // alert("ShowOnOff");
    },
    addImgToCanvasBtn() {
      if (ReadOnlyService.readOnlyActive) return;
      this.showBasicAlert(`Please drag the image into the browser.<br>
                Or upload here: <input type="file" id="manualFileUpload" name="myfile" />`);
      document.getElementById("manualFileUpload").addEventListener(
        "change",
        (e) => {
          $(".basicalert").remove();
          if (ReadOnlyService.readOnlyActive) return;
          e.originalEvent = { dataTransfer: { files: e.target.files } };
          this.handleFileUploadEvent(e);
        },
        false
      );
    },
    handleStamps(toolsname, idx) {
      // alert("test");
      // console.log(toolsname);
      this.svgUrl =
        `${process.env.VUE_APP_SOCKET_URL}:8998` +
        "images/stamp/" +
        toolsname +
        ".png";
      // Call the function directly with your image URL
      // this.svgUrl = `https://192.168.110.98:8990/images/stamp/${toolsname}-Thumbnail.png`
      whiteboard.addImgToCanvasByUrl(String(this.svgUrl));
      console.log("Image uploaded!");
    },
    handleTest() {
      whiteboard.addImgToCanvasByUrl(
        `${process.env.VUE_APP_SOCKET_URL}:8998` +
          "/images/stamp/Keep_It_Up.png"
      );
    },
    saveAsImageBtn() {
      // alert("saveAsImageBtn")
      whiteboard.getImageDataBase64(
        {
          imageFormat: ConfigService.imageDownloadFormat,
          drawBackgroundGrid: ConfigService.drawBackgroundGrid,
        },
        (imgData) => {
          this.imageBase64 = imgData;
          this.uploadTeacherMedia();
          // var w = window.open("about:blank"); //Firefox will not allow downloads without extra window
          // setTimeout(function () {
          //   //FireFox seems to require a setTimeout for this to work.
          //   var a = document.createElement("a");
          //   a.href = imgData;
          //   a.download = "whiteboard." + ConfigService.imageDownloadFormat;
          //   w.document.body.appendChild(a);
          //   a.click();
          //   w.document.body.removeChild(a);
          //   setTimeout(function () {
          //     w.close();
          //   }, 100);
          // }, 0);
        }
      );
    },
    saveAsJSONBtn() {
      var imgData = whiteboard.getImageDataJson();
      this.createImageFromJSON(imgData);
      // var w = window.open("about:blank"); //Firefox will not allow downloads without extra window
      setTimeout(function () {
        //FireFox seems to require a setTimeout for this to work.
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(
          new Blob([imgData], { type: "text/json" })
        );
        // this.jsonFileUrl = a.href;
        // alert(this.jsonFileUrl)
        // a.download = "whiteboard.json";
        // w.document.body.appendChild(a);
        // a.click();
        // w.document.body.removeChild(a);
        setTimeout(function () {
          w.close();
        }, 100);
      }, 0);
    },
    async saveToDbAsJson(type) {
      var imgData = whiteboard.getImageDataJson();
      if (type === "newPage") {
        var classID = this.roomId;
        var fileURL =
          this.MaterialObjectData[this.currentIndexGlobal].FileName.split(
            "."
          )[0] + ".json";
        this.fileUrl =
          process.env.VUE_APP_BASE_URL +
          "/materialmodel/json/" +
          classID +
          "/" +
          fileURL;
        this.prevMaterialCode = this.MaterialCode;
        this.prevMaterialUnit = this.MaterialUnit;
        this.prevMaterialUnitPage = this.MaterialUnitPage;
        this.prevMaterialFileName = this.MaterialFileName;
      }

      console.log("Upload Teacher Media", {
        ClassroomId: this.$store.state.classRoomId,
        MaterialCode: this.prevMaterialCode,
        MaterialUnit: this.prevMaterialUnit,
        MaterialPage: this.prevMaterialUnitPage,
        MaterialFileName: this.prevMaterialFileName,
        JsonString: imgData,
        fileUrl: this.fileUrl,
      });

      if (imgData && this.prevMaterialFileUrl != undefined && imgData != "") {
        this.isLoading = true;
        this.$store
          .dispatch("uploadJsonTeacherMedia", {
            classRoomID: this.$store.state.classRoomId,
            materialCode: this.MaterialCode,
            materialUnit: this.MaterialUnit,
            materialPage: this.MaterialUnitPage,
            MaterialFileName: this.MaterialFileName,
            jsonString: imgData,
            fileUrl: this.fileUrl,
            englishName: this.MaterialFileName,
            chineseName: this.MaterialFileName,
            version: 3,
          })
          .then(() => {
            console.log("test", this.loadNewPage, type);
            var newMaterialData = {};
            if (this.loadNewPage) {
              this.prevIndexGlobal = this.prevIndexGlobal + 1;
              this.nextIndexGlobal = this.nextIndexGlobal + 1;
              this.currentIndexGlobal = this.currentIndexGlobal + 1;
              this.mediaProgressNum = this.currentIndexGlobal + 1;

              console.log(
                "updatedIndexGlobal",
                this.prevIndexGlobal,
                this.nextIndexGlobal,
                this.currentIndexGlobal
              );
              var classID = this.roomId;
              var fileURL = "NEW-" + String(this.mediaProgressNum) + ".json";
              this.MaterialFileType = "json";
              this.MaterialFileName =
                "NEW-" + String(this.mediaProgressNum) + ".json";
              this.MaterialFileUrl =
                process.env.VUE_APP_BASE_URL +
                "/materialmodel/json/" +
                classID +
                "/" +
                fileURL;
              this.MaterialUnitPageId = this.mediaProgressNum - 1;
              this.MaterialUnit = "NEW-" + String(this.mediaProgressNum);
              this.MaterialUnitPage = "NEW-" + String(this.mediaProgressNum);
              this.MaterialCode = "NEW-" + String(this.mediaProgressNum);

              newMaterialData = {
                FileName: this.MaterialFileName,
                FileType: this.MaterialFileType,
                FileUrl: this.MaterialFileUrl,
                MaterialCode: this.MaterialCode,
                MaterialName: this.MaterialFileName,
                MaterialPage: this.MaterialUnitPage,
                MaterialUnit: this.MaterialUnit,
                MaterialUnitPageId: this.MaterialUnitPageId,
              };
              this.MaterialObjectData.splice(
                this.mediaProgressNum - 1,
                0,
                newMaterialData
              );
              console.log("updatedMaterialObjectData", this.MaterialObjectData);
              this.loadNewPage = false;
            }
            if (type == "newPage") {
              whiteboard.clearWhiteboard();
              this.socket.emit("updateNewMaterial", {
                prevIndexGlobal: this.prevIndexGlobal,
                nextIndexGlobal: this.nextIndexGlobal,
                currentIndexGlobal: this.currentIndexGlobal,
                newMaterial: newMaterialData,
              });
              this.socket.emit(
                "setCurrentIndexGlobal",
                this.currentIndexGlobal
              );
              const renderedWidth = "1200";
              const renderedHeight = "1500";

              const canvas = document.getElementById("whiteboardCanvas");
              canvas.width = renderedWidth;
              canvas.height = renderedHeight;

              $("#whiteboardCanvas").css({
                width: renderedWidth,
                height: renderedHeight,
              });
              $("#textContainer").css({
                width: renderedWidth,
                height: renderedHeight,
              });
              $("#mouseOverlay").css({
                width: renderedWidth,
                height: renderedHeight,
              });
              $("#imgContainer").css({
                width: renderedWidth,
                height: renderedHeight,
              });
              $("#backgroundGrid").css({
                width: renderedWidth,
                height: renderedHeight,
              });
              $("#svgContainer").css({
                width: renderedWidth,
                height: renderedHeight,
              });
              $("#dropIndicator").css({
                width: renderedWidth,
                height: renderedHeight,
              });
              $("#cursorContainer").css({
                width: renderedWidth,
                height: renderedHeight,
              });
              $("#loadingMedia").css({
                width: renderedWidth,
                height: renderedHeight,
              });
            }
          });
      }
    },
    createImageFromJSON(jsonData) {
      const data = JSON.parse(jsonData);
      const canvas = document.createElement("canvas");
      canvas.width = data.width;
      canvas.height = data.height;
      const ctx = canvas.getContext("2d");

      const imageData = ctx.createImageData(data.width, data.height);

      for (let i = 0; i < data.pixels.length; i += 3) {
        imageData.data[i] = data.pixels[i];
        imageData.data[i + 1] = data.pixels[i + 1];
        imageData.data[i + 2] = data.pixels[i + 2];
        imageData.data[i + 3] = 255; // Alpha value (255 means fully opaque)
      }

      ctx.putImageData(imageData, 0, 0);

      // Get the PNG data URL
      const pngDataUrl = canvas.toDataURL("image/png");

      // Now, you can use the pngDataUrl or do something with it (e.g., display the image on the page, download it, etc.).
      console.log(pngDataUrl);
    },
    uploadWebDavBtn() {
      if ($(".webdavUploadBtn").length > 0) {
        return;
      }

      var webdavserver = localStorage.getItem("webdavserver") || "";
      var webdavpath = localStorage.getItem("webdavpath") || "/";
      var webdavusername = localStorage.getItem("webdavusername") || "";
      var webdavpassword = localStorage.getItem("webdavpassword") || "";
      var webDavHtml = $(
        `<div>
                        <table>
                            <tr>
                                <td>Server URL:</td>
                                <td><input class="webdavserver" type="text" value="${webdavserver}" placeholder="https://yourserver.com/remote.php/webdav/"></td>
                                <td></td>
                            </tr>
                        <tr>
                            <td>Path:</td>
                            <td><input class="webdavpath" type="text" placeholder="folder" value="${webdavpath}"></td>
                            <td style="font-size: 0.7em;"><i>path always have to start & end with "/"</i></td>
                        </tr>
                        <tr>
                            <td>Username:</td>
                            <td><input class="webdavusername" type="text" value="${webdavusername}" placeholder="username"></td>
                            <td style="font-size: 0.7em;"></td>
                        </tr>
                        <tr>
                            <td>Password:</td>
                            <td><input class="webdavpassword" type="password" value="${webdavpassword}" placeholder="password"></td>
                            <td style="font-size: 0.7em;"></td>
                        </tr>
                        <tr>
                            <td style="font-size: 0.7em;" colspan="3">
                                Note: You have to generate and use app credentials if you have 2 Factor Auth activated on your dav/nextcloud server!
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td colspan="2">
                                <span class="loadingWebdavText" style="display:none;">Saving to webdav, please wait...</span><button class="modalBtn webdavUploadBtn"><i class="fas fa-upload"></i> Start Upload</button>
                            </td>
                        </tr>
                        </table>
                    </div>`
      );
      webDavHtml
        .find(".webdavUploadBtn")
        .off("click")
        .click(function () {
          var webdavserver = webDavHtml.find(".webdavserver").val();
          localStorage.setItem("webdavserver", webdavserver);
          var webdavpath = webDavHtml.find(".webdavpath").val();
          localStorage.setItem("webdavpath", webdavpath);
          var webdavusername = webDavHtml.find(".webdavusername").val();
          localStorage.setItem("webdavusername", webdavusername);
          var webdavpassword = webDavHtml.find(".webdavpassword").val();
          localStorage.setItem("webdavpassword", webdavpassword);
          whiteboard.getImageDataBase64(
            {
              imageFormat: ConfigService.imageDownloadFormat,
              drawBackgroundGrid: ConfigService.drawBackgroundGrid,
            },
            function (base64data) {
              var webdavaccess = {
                webdavserver: webdavserver,
                webdavpath: webdavpath,
                webdavusername: webdavusername,
                webdavpassword: webdavpassword,
              };
              webDavHtml.find(".loadingWebdavText").show();
              webDavHtml.find(".webdavUploadBtn").hide();
              saveWhiteboardToWebdav(base64data, webdavaccess, function (err) {
                if (err) {
                  webDavHtml.find(".loadingWebdavText").hide();
                  webDavHtml.find(".webdavUploadBtn").show();
                } else {
                  webDavHtml.parents(".basicalert").remove();
                }
              });
            }
          );
        });
      this.showBasicAlert(webDavHtml, {
        header: "Save to Webdav",
        okBtnText: "cancel",
        headercolor: "#0082c9",
      });
      // render newly added icons
      dom.i2svg();
    },
    uploadJsonBtn() {
      $("#myFile").click();
    },
    loadJson() {
      var file = document.getElementById("myFile").files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        try {
          var j = JSON.parse(e.target.result);
          whiteboard.loadJsonData(j);
        } catch (e) {
          showBasicAlert("File was not a valid JSON!");
        }
      };
      reader.readAsText(file);
      $(this).val("");
    },
    async loadJsonFromDatabase(classroomId, englishName, materialUnit, materialPage, type, fallbackImg, imgTempId) {
      var safeUnit = materialUnit || "none";
      var safePage = materialPage || "none";
      var safeName = englishName || "none";
      console.log("loadJsonFromDatabase", classroomId, safeName, safeUnit, safePage);
      try {
        const response = await this.$axios.get(
          `/materialmodel/json/load/${encodeURIComponent(classroomId)}/${encodeURIComponent(safeName)}/${encodeURIComponent(safeUnit)}/${encodeURIComponent(safePage)}`
        );

        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          whiteboard.clearWhiteboard(() => {
            whiteboard.loadJsonData(response.data);
            if (type != "firstLoad") {
              this.socket.emit("setLoadJsonFromDatabase", {
                roomId: classroomId,
                englishName: englishName,
                materialUnit: materialUnit,
                materialPage: materialPage,
                type: type,
                sendState: false,
              });
            }
            if (type == "new") {
              $("#loadingMedia").css({ display: "none" });
              $("#loadingMedia").css({ zIndex: "0" });
              this.pageChangeSet();
            }
          });
        }
      } catch (error) {
        console.log("loadJsonFromDatabase: 此页无绘图数据", error?.response?.status);
        // 无 JSON 数据 → 回退到教材背景图
        if (fallbackImg) {
          this.setBackgroundDynamic4(fallbackImg, imgTempId, type);
          this.currentBackgroundImage = fallbackImg;
        } else {
          $("#loadingMedia").css({ display: "none" });
          $("#loadingMedia").css({ zIndex: "0" });
        }
      }
    },
    async loadJsonFromDatabaseClient(classroomId, englishName, materialUnit, materialPage, type, sendState = true, callback) {
      var safeUnit = materialUnit || "none";
      var safePage = materialPage || "none";
      var safeName = englishName || "none";
      console.log("loadJsonFromDatabaseClient", classroomId, safeName, safeUnit, safePage);

      // 切頁前先清除舊筆跡，ReadOnly 端不能呼叫 clearSelfWhiteboard（no-op），
      // 改用事件路徑清除，不受 ReadOnly 限制
      whiteboard.loadCurrentData([{t: "clearDrawing"}], false);

      try {
        const response = await this.$axios.get(
          `/materialmodel/json/load/${encodeURIComponent(classroomId)}/${encodeURIComponent(safeName)}/${encodeURIComponent(safeUnit)}/${encodeURIComponent(safePage)}`
        );

        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          whiteboard.loadJsonData(response.data, true, () => {
            if (callback) callback(this.imageExists(response.data));
          });
        } else {
          if (callback) callback(false);
        }
      } catch (error) {
        console.log("loadJsonFromDatabaseClient: 此页无绘图数据", error?.response?.status);
        if (callback) callback(false);
      }
    },
    imageExists(content) {
      if (content && Array.isArray(content)) {
        return content.some(item => item && item["t"] === "addImgContentAsBG");
      }
      return false
    },
    shareWhiteboardBtn() {
      function urlToClipboard(whiteboardId = null) {
        const { protocol, host, pathname, search } = window.location;
        const basePath = `${protocol}//${host}${pathname}`;
        const getParams = new URLSearchParams(search);

        // Clear ursername from get parameters
        getParams.delete("username");

        if (whiteboardId) {
          // override whiteboardId value in URL
          getParams.set("whiteboardid", whiteboardId);
        }

        const url = `${basePath}?${getParams.toString()}`;
        $("<textarea/>")
          .appendTo("body")
          .val(url)
          .select()
          .each(() => {
            document.execCommand("copy");
          })
          .remove();
      }

      // UI related
      // clear message
      $("#shareWhiteboardDialogMessage").toggleClass("displayNone", true);

      $("#shareWhiteboardDialog").toggleClass("displayNone", false);
      $("#shareWhiteboardDialogGoBack")
        .off("click")
        .click(() => {
          $("#shareWhiteboardDialog").toggleClass("displayNone", true);
        });

      $("#shareWhiteboardDialogCopyReadOnlyLink")
        .off("click")
        .click(() => {
          urlToClipboard(ConfigService.correspondingReadOnlyWid);

          $("#shareWhiteboardDialogMessage")
            .toggleClass("displayNone", false)
            .text("Read-only link copied to clipboard ✓");
        });

      $("#shareWhiteboardDialogCopyReadWriteLink")
        .toggleClass("displayNone", ConfigService.isReadOnly)
        .click(() => {
          $("#shareWhiteboardDialogMessage")
            .toggleClass("displayNone", false)
            .text("Read/write link copied to clipboard ✓");
          urlToClipboard();
        });
    },
    displayWhiteboardInfoBtn() {
      InfoService.toggleDisplayInfo();
    },
    minMaxBtn() {
      if (!this.btnsMini) {
        $("#toolbar").find(".btn-group:not(.minGroup)").hide();
        $("#minBtn").hide();
        $("#maxBtn").show();
      } else {
        $("#toolbar").find(".btn-group").show();
        $("#minBtn").show();
        $("#maxBtn").hide();
      }
      this.btnsMini = !this.btnsMini;
    },
    loadJson() {
      var file = document.getElementById("myFile").files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        try {
          var j = JSON.parse(e.target.result);
          whiteboard.loadJsonData(j);
        } catch (e) {
          showBasicAlert("File was not a valid JSON!");
        }
      };
      reader.readAsText(file);
      $(this).val("");
    },
    whiteboardThicknessSlider(e) {
      if (ReadOnlyService.readOnlyActive) return;
      whiteboard.setStrokeThickness($(e.currentTarget).val());
      let activeTool = $(".whiteboard-tool.active").attr("tool");
      localStorage.setItem(
        "item_thickness_" + activeTool,
        $(e.currentTarget).val()
      );
    },
    whiteboardUndoBtn() {
      whiteboard.undoWhiteboardClick();
    },
    whiteboardRedoBtn() {
      whiteboard.redoWhiteboardClick();
    },
    handleDragEnter(e) {
      if (ReadOnlyService.readOnlyActive) return;
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter++;
      // whiteboard.dropIndicator.show();
    },
    handleDragLeave(e) {
      if (ReadOnlyService.readOnlyActive) return;
      e.preventDefault();
      e.stopPropagation();
      this.dragCounter--;
      if (this.dragCounter === 0) {
        whiteboard.dropIndicator.hide();
      }
    },
    handleDrop(e) {
      //Handle drop
      if (ReadOnlyService.readOnlyActive) return;

      this.handleFileUploadEvent(e);
      this.dragCounter = 0;
      whiteboard.dropIndicator.hide();
    },
    handleFileUploadEvent(e) {
      console.log(e);
      if (e.dataTransfer === undefined) {
        if (e.originalEvent.dataTransfer) {
          if (e.originalEvent.dataTransfer.files.length) {
            //File from harddisc
            e.preventDefault();
            e.stopPropagation();
            var filename = e.originalEvent.dataTransfer.files[0]["name"];
            if (this.isImageFileName(filename)) {
              var blob = e.originalEvent.dataTransfer.files[0];
              var reader = new window.FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = () => {
                const base64data = reader.result;
                this.uploadImgAndAddToWhiteboard(base64data);
              };
            } else if (isPDFFileName(filename)) {
              //Handle PDF Files
              var blob = e.dataTransfer.files[0];

              var reader = new window.FileReader();
              reader.onloadend = function () {
                var pdfData = new Uint8Array(this.result);

                var loadingTask = pdfjsLib.getDocument({ data: pdfData });
                loadingTask.promise.then(
                  function (pdf) {
                    console.log("PDF loaded");

                    var currentDataUrl = null;
                    var modalDiv = $(
                      "<div>" +
                        "Page: <select></select> " +
                        '<button style="margin-bottom: 3px;" class="modalBtn"><i class="fas fa-upload"></i> Upload to Whiteboard</button>' +
                        '<img style="width:100%;" src=""/>' +
                        "</div>"
                    );

                    modalDiv.find("select").change(function () {
                      showPDFPageAsImage(parseInt($(this).val()));
                    });

                    modalDiv
                      .find("button")
                      .off("click")
                      .click(() => {
                        if (currentDataUrl) {
                          $(".basicalert").remove();
                          this.uploadImgAndAddToWhiteboard(currentDataUrl);
                        }
                      });

                    for (var i = 1; i < pdf.numPages + 1; i++) {
                      modalDiv
                        .find("select")
                        .append('<option value="' + i + '">' + i + "</option>");
                    }

                    this.showBasicAlert(modalDiv, {
                      header: "Pdf to Image",
                      okBtnText: "cancel",
                      headercolor: "#0082c9",
                    });

                    // render newly added icons
                    dom.i2svg();

                    showPDFPageAsImage(1);
                    function showPDFPageAsImage(pageNumber) {
                      // Fetch the page
                      pdf.getPage(pageNumber).then(function (page) {
                        console.log("Page loaded");

                        var scale = 1.5;
                        var viewport = page.getViewport({ scale: scale });

                        // Prepare canvas using PDF page dimensions
                        var canvas = $("<canvas></canvas>")[0];
                        var context = canvas.getContext("2d");
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        // Render PDF page into canvas context
                        var renderContext = {
                          canvasContext: context,
                          viewport: viewport,
                        };
                        var renderTask = page.render(renderContext);
                        renderTask.promise.then(function () {
                          var dataUrl = canvas.toDataURL("image/jpeg", 1.0);
                          currentDataUrl = dataUrl;
                          modalDiv.find("img").attr("src", dataUrl);
                          console.log("Page rendered");
                        });
                      });
                    }
                  },
                  function (reason) {
                    // PDF loading error

                    showBasicAlert(
                      "Error loading pdf as image! Check that this is a vaild pdf file!"
                    );
                    console.error(reason);
                  }
                );
              };
              reader.readAsArrayBuffer(blob);
            } else {
              showBasicAlert("File must be an image!");
            }
          } else {
            //File from other browser

            var fileUrl = e.originalEvent.dataTransfer.getData("URL");
            var imageUrl = e.originalEvent.dataTransfer.getData("text/html");
            var rex = /src="?([^"\s]+)"?\s*/;
            var url = rex.exec(imageUrl);
            if (url && url.length > 1) {
              url = url[1];
            } else {
              url = "";
            }

            isValidImageUrl(fileUrl, (isImage) => {
              if (isImage && this.isImageFileName(url)) {
                whiteboard.addImgToCanvasByUrl(fileUrl);
              } else {
                isValidImageUrl(url, (isImage) => {
                  if (isImage) {
                    if (this.isImageFileName(url) || url.startsWith("http")) {
                      whiteboard.addImgToCanvasByUrl(url);
                    } else {
                      this.uploadImgAndAddToWhiteboard(url); //Last option maybe its base64
                    }
                  } else {
                    showBasicAlert("Can only upload Imagedata!");
                  }
                });
              }
            });
          }
        }
      } else {
        if (e.dataTransfer) {
          if (e.dataTransfer.files.length) {
            //File from harddisc
            e.preventDefault();
            e.stopPropagation();
            var filename = e.dataTransfer.files[0]["name"];
            if (this.isImageFileName(filename)) {
              var blob = e.dataTransfer.files[0];
              var reader = new window.FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = () => {
                const base64data = reader.result;
                this.uploadImgAndAddToWhiteboard(base64data);
              };
            } else if (isPDFFileName(filename)) {
              //Handle PDF Files
              var blob = e.dataTransfer.files[0];

              var reader = new window.FileReader();
              reader.onloadend = function () {
                var pdfData = new Uint8Array(this.result);

                var loadingTask = pdfjsLib.getDocument({ data: pdfData });
                loadingTask.promise.then(
                  function (pdf) {
                    console.log("PDF loaded");

                    var currentDataUrl = null;
                    var modalDiv = $(
                      "<div>" +
                        "Page: <select></select> " +
                        '<button style="margin-bottom: 3px;" class="modalBtn"><i class="fas fa-upload"></i> Upload to Whiteboard</button>' +
                        '<img style="width:100%;" src=""/>' +
                        "</div>"
                    );

                    modalDiv.find("select").change(function () {
                      showPDFPageAsImage(parseInt($(this).val()));
                    });

                    modalDiv
                      .find("button")
                      .off("click")
                      .click(() => {
                        if (currentDataUrl) {
                          $(".basicalert").remove();
                          this.uploadImgAndAddToWhiteboard(currentDataUrl);
                        }
                      });

                    for (var i = 1; i < pdf.numPages + 1; i++) {
                      modalDiv
                        .find("select")
                        .append('<option value="' + i + '">' + i + "</option>");
                    }

                    this.showBasicAlert(modalDiv, {
                      header: "Pdf to Image",
                      okBtnText: "cancel",
                      headercolor: "#0082c9",
                    });

                    // render newly added icons
                    dom.i2svg();

                    showPDFPageAsImage(1);
                    function showPDFPageAsImage(pageNumber) {
                      // Fetch the page
                      pdf.getPage(pageNumber).then(function (page) {
                        console.log("Page loaded");

                        var scale = 1.5;
                        var viewport = page.getViewport({ scale: scale });

                        // Prepare canvas using PDF page dimensions
                        var canvas = $("<canvas></canvas>")[0];
                        var context = canvas.getContext("2d");
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;

                        // Render PDF page into canvas context
                        var renderContext = {
                          canvasContext: context,
                          viewport: viewport,
                        };
                        var renderTask = page.render(renderContext);
                        renderTask.promise.then(function () {
                          var dataUrl = canvas.toDataURL("image/jpeg", 1.0);
                          currentDataUrl = dataUrl;
                          modalDiv.find("img").attr("src", dataUrl);
                          console.log("Page rendered");
                        });
                      });
                    }
                  },
                  function (reason) {
                    // PDF loading error

                    showBasicAlert(
                      "Error loading pdf as image! Check that this is a vaild pdf file!"
                    );
                    console.error(reason);
                  }
                );
              };
              reader.readAsArrayBuffer(blob);
            } else {
              showBasicAlert("File must be an image!");
            }
          } else {
            //File from other browser

            var fileUrl = e.dataTransfer.getData("URL");
            var imageUrl = e.dataTransfer.getData("text/html");
            var rex = /src="?([^"\s]+)"?\s*/;
            var url = rex.exec(imageUrl);
            if (url && url.length > 1) {
              url = url[1];
            } else {
              url = "";
            }

            isValidImageUrl(fileUrl, (isImage) => {
              if (isImage && this.isImageFileName(url)) {
                whiteboard.addImgToCanvasByUrl(fileUrl);
              } else {
                isValidImageUrl(url, (isImage) => {
                  if (isImage) {
                    if (this.isImageFileName(url) || url.startsWith("http")) {
                      whiteboard.addImgToCanvasByUrl(url);
                    } else {
                      this.uploadImgAndAddToWhiteboard(url); //Last option maybe its base64
                    }
                  } else {
                    showBasicAlert("Can only upload Imagedata!");
                  }
                });
              }
            });
          }
        }
      }
    },
    changeColor(color) {
      this.paletteBackground = color;
      $("#whiteboardColorpicker").css({ background: this.paletteBackground });
    },
    intColorPicker(initColor) {
      const _this = this;
      if (this.colorPicker) {
        this.colorPicker.destroy();
      }
      this.colorPicker = new Picker({
        parent: $("#whiteboardColorpicker")[0],
        color: initColor || "#000000",
        onChange: function (color) {
          whiteboard.setDrawColor(color.rgbaString);
          _this.changeColor(color.rgbaString);
        },
        onDone: function (color) {
          let palette = JSON.parse(localStorage.getItem("savedColors"));
          if (!palette.includes(color.rgbaString)) {
            palette.push(color.rgbaString);
            localStorage.setItem("savedColors", JSON.stringify(palette));
          }
          _this.changeColor(color.rgbaString);
          _this.intColorPicker(color.rgbaString);
        },
        onOpen: colorPickerOnOpen,
        template: colorPickerTemplate,
      });
    },
    intBgColorPicker(initColor) {
      if (this.bgColorPicker) {
        this.bgColorPicker.destroy();
      }
      this.bgColorPicker = new Picker({
        parent: $("#textboxBackgroundColorPicker")[0],
        // color: initColor || "#f5f587",
        // bgcolor: initColor || "#f5f587",
        color: initColor || "rgba(0,0,0,0)",
        bgcolor: initColor || "rgba(0,0,0,0)",
        onChange: function (bgcolor) {
          whiteboard.setTextBackgroundColor(bgcolor.rgbaString);
        },
        onDone: (bgcolor) => {
          let palette = JSON.parse(localStorage.getItem("savedColors"));
          if (!palette.includes(color.rgbaString)) {
            palette.push(color.rgbaString);
            localStorage.setItem("savedColors", JSON.stringify(palette));
          }
          this.intBgColorPicker(color.rgbaString);
        },
        onOpen: colorPickerOnOpen,
        template: colorPickerTemplate,
      });
    },
    uploadImgAndAddToWhiteboard(base64data) {
      const date = +new Date();
      $.ajax({
        type: "POST",
        url:
          document.URL.substr(0, document.URL.lastIndexOf("/")) + "/api/upload",
        data: {
          imagedata: base64data,
          wid: whiteboardId,
          date: date,
          at: this.accessToken,
        },
        success: (msg) => {
          const { correspondingReadOnlyWid } = ConfigService;
          const filename = `${correspondingReadOnlyWid}_${date}.png`;
          const rootUrl = document.URL.substr(0, document.URL.lastIndexOf("/"));
          whiteboard.addImgToCanvasByUrl(
            `${rootUrl}/uploads/${correspondingReadOnlyWid}/${filename}`
          ); //Add image to canvas
          console.log("Image uploaded!");
        },
        error: (err) => {
          this.showBasicAlert("Failed to upload frame: " + JSON.stringify(err));
        },
      });
    },
    saveWhiteboardToWebdav(base64data, webdavaccess, callback) {
      var date = +new Date();
      $.ajax({
        type: "POST",
        url:
          document.URL.substr(0, document.URL.lastIndexOf("/")) + "/api/upload",
        data: {
          imagedata: base64data,
          wid: whiteboardId,
          date: date,
          at: this.accessToken,
          webdavaccess: JSON.stringify(webdavaccess),
        },
        success: (msg) => {
          this.showBasicAlert("Whiteboard was saved to Webdav!", {
            headercolor: "#5c9e5c",
          });
          console.log("Image uploaded to webdav!");
          callback();
        },
        error: (err) => {
          console.error(err);
          if (err.status == 403) {
            this.showBasicAlert(
              "Could not connect to Webdav folder! Please check the credentials and paths and try again!"
            );
          } else {
            this.showBasicAlert("Unknown Webdav error! ", err);
          }
          callback(err);
        },
      });
    },
    isImageFileName(filename) {
      var extension = filename.split(".")[filename.split(".").length - 1];
      var known_extensions = [
        "png",
        "jpg",
        "jpeg",
        "gif",
        "tiff",
        "bmp",
        "webp",
      ];
      return known_extensions.includes(extension.toLowerCase());
    },
    isPDFFileName(filename) {
      var extension = filename.split(".")[filename.split(".").length - 1];
      var known_extensions = ["pdf"];
      return known_extensions.includes(extension.toLowerCase());
    },
    isValidImageUrl(url, callback) {
      var img = new Image();
      var timer = null;
      img.onerror = img.onabort = function () {
        clearTimeout(timer);
        callback(false);
      };
      img.onload = function () {
        clearTimeout(timer);
        callback(true);
      };
      timer = setTimeout(function () {
        callback(false);
      }, 2000);
      img.src = url;
    },
    thicknessSlide() {
      if (this.thicknessSlideState) {
        $("#thicknessSlide").show();
        $("#thicknessSlide").hide();
      } else {
        $("#thicknessSlide").hide();
        $("#thicknessSlide").show();
      }
      this.thicknessSlideState = !this.thicknessSlideState;
    },
    setZoom(zoom) {
      if (this.zoom == 1) {
        this.originalWidth = $("#ContextImgAsBackground").width();
        this.originalHeight = $("#ContextImgAsBackground").height();
      }

      if (this.zoom + zoom > 0.5) {
        $("#ContextImgAsBackground").css({ width: "100%", height: "100%" });
        this.zoom += zoom;
        var top = 0;
        var left = 0;

        if (this.zoom > 1) {
          top = Math.abs(this.originalHeight * (this.zoom - 1)) / 2;
          left = Math.abs(this.originalWidth * (this.zoom - 1)) / 2;
        }

        if (this.zoom < 1) {
          top = -(Math.abs(this.originalHeight * (this.zoom - 1)) / 2);
        }

        if (
          this.zoom == 1 &&
          $("#ContextImgAsBackground").height() <
            $("#whiteboardContainer").height()
        ) {
          transform = `translate(0px, -50%)`;
          const position = {
            transform: transform,
            top: "50%",
          };
          $(
            "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
          ).css(position);
        } else {
          var transform = `translate(${left}px, ${top}px) scale(${this.zoom})`;
          const position = {
            transform: transform,
          };
          $(
            "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
          ).css(position);
        }

        if (
          $("#ContextImgAsBackground").height() * this.zoom <
          $("#whiteboardContainer").height()
        ) {
          transform = `translate(${left}px, -50%) scale(${this.zoom})`;
          const position = {
            transform: transform,
            top: "50%",
          };
          $(
            "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
          ).css(position);
        } else {
          var transform = `translate(${left}px, ${top}px) scale(${this.zoom})`;
          const position = {
            transform: transform,
            top: `0px`,
          };
          $(
            "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
          ).css(position);
        }
      }
      this.$nextTick(() => {
        this.updateThumb();
      });
    },
    //--------------------------------------//

    //------------Content-------------------//

    async previousPicture(type) {
      // alert(this.zoomFactor);
      // this.fabricHistoryJson = [];

      if (this.MaterialObjectData.length > 0) {
        $(".book_scroll").animate({ scrollTop: "0px" }, 1000);
        var currentIndex = this.prevIndexGlobal;
        var prevIndex = currentIndex - 1;
        var nextIndex = currentIndex + 1;
        this.imgTempId = "obj-" + currentIndex;
        for (let i = 0; i < this.MaterialObjectData.length; i++) {
          var elem = "obj-" + i;
          if (i !== this.currentIndex) {
            if (document.getElementById(elem)) {
              var element = document.getElementById(elem).firstChild;
              element.style.removeProperty("border");
            }
          }
        }

        if (currentIndex < 0) {
          prevIndex = 0;
          let lengthPaginationLayer = this.paginationLayers.length - 1;
          var responseMaterial;
          if (this.currentLayer > -1) {
            if (lengthPaginationLayer > -1) {
              // if (lengthPaginationLayer > 0) {
              //   responseMaterial = await this.$store.dispatch(
              //     "fetchHitutorMedia",
              //     {
              //       ClassroomId: this.$store.state.classRoomId,
              //       LastPage: this.paginationLayers[this.currentLayer],
              //       RequestPages: 10,
              //     }
              //   );
              // } else {
              //   responseMaterial = await this.$store.dispatch(
              //     "fetchHitutorMedia",
              //     {
              //       ClassroomId: this.$store.state.classRoomId,
              //       LastPage: this.paginationLayers[0],
              //       RequestPages: 10,
              //     }
              //   );
              // }

              if (lengthPaginationLayer > 0) {
                responseMaterial = await this.$store.dispatch(
                  "fetchHitutorMedia",
                  {
                    ClassroomId: this.$store.state.classRoomId,
                    LastPage: this.paginationLayers[this.currentLayer],
                    RequestPages: 10,
                  }
                );
              } else {
                responseMaterial = await this.$store.dispatch(
                  "fetchHitutorMedia",
                  {
                    ClassroomId: this.$store.state.classRoomId,
                    LastPage: this.paginationLayers[0],
                    RequestPages: 10,
                  }
                );
              }

              // this.paginationLayers = this.paginationLayers[-1]

              if (responseMaterial.data.IsSuccess == true) {
                this.MaterialObjectData = responseMaterial.data.MaterialObject;
                this.MaterialVedioObjectData =
                  responseMaterial.data.MaterialVedioObject;
                this.MaterialMediaObject =
                  responseMaterial.data.MaterialMediaObject;

                this.nextIndexGlobal = this.MaterialObjectData.length;
                currentIndex = this.MaterialObjectData.length - 1;
                prevIndex = currentIndex - 1;
                nextIndex = this.nextIndexGlobal;
                this.currentLayer = this.currentLayer - 1;
                // this.nextIndexGlobal=this.MaterialObjectData.length-1;
                // currentIndex=this.nextIndexGlobal;
                // prevIndex=currentIndex-1;
                // this.nextIndexGlobal=this.MaterialObjectData.length-1;
                // currentIndex=this.nextIndexGlobal;
                // prevIndex=currentIndex-1;
                // nextIndex=this.nextIndexGlobal;
              } else {
                currentIndex = 0;
                prevIndex = 0;
                nextIndex = currentIndex + 1;
              }
            } else {
              this.currentLayer = 0;
              currentIndex = 0;
              prevIndex = 0;
              nextIndex = currentIndex + 1;
            }
          } else {
            currentIndex = 0;
            prevIndex = 0;
            nextIndex = currentIndex + 1;
          }
        }

        try {
          this.visibleImage = currentIndex;
          this.prevMaterialFileType = this.MaterialFileType;
          this.prevMaterialFileName = this.MaterialFileName;
          this.prevMaterialFileUrl = this.MaterialFileUrl;
          this.prevMaterialUnitPageId = this.MaterialUnitPageId;
          this.prevMaterialUnit = this.MaterialUnit;
          this.prevMaterialUnitPage = this.MaterialUnitPage;
          this.prevMaterialCode = this.MaterialCode;

          this.MaterialFileType =
            this.MaterialObjectData[currentIndex].FileType;
          this.MaterialFileName =
            this.MaterialObjectData[currentIndex].FileName;
          this.MaterialFileUrl = this.MaterialObjectData[currentIndex].FileUrl;
          this.MaterialUnitPageId =
            this.MaterialObjectData[currentIndex].MaterialUnitPageId;
          this.MaterialUnit =
            this.MaterialObjectData[currentIndex].MaterialUnit;
          this.MaterialUnitPage =
            this.MaterialObjectData[currentIndex].MaterialPage;
          this.MaterialCode =
            this.MaterialObjectData[currentIndex].MaterialCode;

          var imgTemp = document.querySelector("#obj-" + currentIndex);

          this.SELECTIMGWIDTH = imgTemp.children[0].naturalWidth;
          this.SELECTIMGHEIGHT = imgTemp.children[0].naturalHeight;
        } catch (error) {}

        var img = this.MaterialObjectData[currentIndex].FileUrl;

        // 同步 EnglishFileName
        this.EnglishFileName = this.MaterialCode === "NewPage"
          ? "New" + this.MaterialFileName : this.MaterialFileName;
        this.ChineseFileName = this.MaterialFileName;

        // 构造 fileData 供 socket emit 使用
        var fileData = `${this.roomId}|${this.MaterialUnitPageId}|${this.MaterialUnit}|${this.MaterialUnitPage}|${this.EnglishFileName}|${this.MaterialName}`;

        // 检查是否 NewPage 并设置画布
        if (this.MaterialCode === "NewPage") {
          type = "new";
          this.setupCanvasAndResizeElements("100%", "100%");
        }

        // 直接用确定性参数加载，传入 fallbackImg 回退到教材背景图
        this.loadJsonFromDatabase(
          this.roomId, this.EnglishFileName,
          this.MaterialUnit, this.MaterialUnitPage, type,
          img, this.imgTempId
        );

        this.versions = 0;
        this.fileUrl = this.currentBackgroundImage;
        this.prevIndexGlobal = prevIndex;
        this.nextIndexGlobal = nextIndex;
        this.currentIndexGlobal = currentIndex;
        this.mediaProgressNum = this.currentIndexGlobal + 1;
        this.socket.emit("setImgTempId", {
          roomId: String(this.roomId),
          status: "previous",
          type: type,
          num: [
            this.prevIndexGlobal,
            this.nextIndexGlobal,
            this.currentIndexGlobal,
            this.mediaProgressNum,
          ],
          file: fileData,
        });

        if (this.MaterialObjectData.length > 0) {
          //Send Image to Hitutor
          // var originalTransform = this.fabricObj.viewportTransform;
          // this.fabricObj.viewportTransform = fabric.iMatrix.slice(0);
          // let base64URl = this.fabricObj.toDataURL({
          //   format: "image/jpg",
          //   multiplier: 1,
          // });
          // this.fabricObj.viewportTransform = originalTransform;
          // this.imageBase64 = base64URl;

          if (
            this.prevMaterialFileType !== "" &&
            this.prevMaterialFileName !== "" &&
            this.prevMaterialFileUrl !== "" &&
            this.prevMaterialUnitPageId !== "" &&
            this.prevMaterialUnit !== "" &&
            this.prevMaterialUnitPage !== "" &&
            this.prevMaterialCode !== "" &&
            this.prevMaterialFileType !== undefined &&
            this.prevMaterialFileName !== undefined &&
            this.prevMaterialFileUrl !== undefined &&
            this.prevMaterialUnitPageId !== undefined &&
            this.prevMaterialUnit !== undefined &&
            this.prevMaterialUnitPage !== undefined &&
            this.prevMaterialCode !== undefined &&
            this.prevMaterialFileType !== null &&
            this.prevMaterialFileName !== null &&
            this.prevMaterialFileUrl !== null &&
            this.prevMaterialUnitPageId !== null &&
            this.prevMaterialUnit !== null &&
            this.prevMaterialUnitPage !== null &&
            this.prevMaterialCode !== null
          ) {
            // this.uploadTeacherMedia();
          }

          // this.fabricObj.clear();
        }
      }
    },
    hasProperty(obj, propertyName) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop))
          if (prop == propertyName) {
            return true;
          }
      }
      return false;
    },
    async nextPicture(type) {
      // alert(this.zoomFactor);
      // this.fabricHistoryJson = [];
      // console.log(this.nextIndexGlobal)

      if (this.MaterialObjectData.length > 0) {
        $(".book_scroll").animate({ scrollTop: "0px" }, 1000);
        var currentIndex = this.nextIndexGlobal;
        var prevIndex = currentIndex - 1;
        var nextIndex = currentIndex + 1;
        this.imgTempId = "obj-" + currentIndex;

        // console.log(currentIndex)

        for (let i = 0; i < this.MaterialObjectData.length; i++) {
          var elem = "obj-" + i;
          if (i !== this.currentIndex) {
            if (document.getElementById(elem)) {
              var element = document.getElementById(elem).firstChild;
              element.style.removeProperty("border");
            }
          }
        }

        if (nextIndex > this.MaterialObjectData.length) {
          // nextIndex=this.MaterialObjectData.length-1;

          const responseMaterial = await this.$store.dispatch(
            "fetchHitutorMedia",
            {
              ClassroomId: this.$store.state.classRoomId,
              LastPage: this.MaterialUnitPageId,
              RequestPages: 10,
            }
          );
          if (responseMaterial.data.IsSuccess == true) {
            this.theLastLastPage =
              this.MaterialObjectData[0].MaterialUnitPageId;
            //const isAnyMessageProps = Object.hasOwn(responseMaterial.data, "Message");
            const isAnyMessageProps = this.hasProperty(
              responseMaterial.data,
              "Message"
            );

            if (isAnyMessageProps == false || isAnyMessageProps === false) {
              this.MaterialObjectData = responseMaterial.data.MaterialObject;
              this.MaterialVedioObjectData =
                responseMaterial.data.MaterialVedioObject;
              this.MaterialMediaObject =
                responseMaterial.data.MaterialMediaObject;

              if (
                this.MaterialObjectData[0].MaterialUnitPageId !=
                  this.theLastLastPage ||
                this.MaterialObjectData[0].MaterialUnitPageId !==
                  this.theLastLastPage
              ) {
                if (this.paginationLayers.length > 0) {
                  if (this.paginationLayers.includes(this.theLastLastPage)) {
                  } else {
                    this.paginationLayers.push(this.theLastLastPage);
                  }
                } else {
                  this.paginationLayers.push(this.theLastLastPage);
                }
                this.nextIndexGlobal = 1;
                currentIndex = 0;
                prevIndex = -1;
                nextIndex = currentIndex + 1;

                this.currentLayer = this.currentLayer + 1;
                if (this.currentLayer > this.paginationLayers.length - 1) {
                  this.currentLayer = this.paginationLayers.length - 1;
                }
              } else {
                currentIndex = this.MaterialObjectData.length - 1;
                nextIndex = this.MaterialObjectData.length - 1;
                prevIndex = currentIndex - 1;
              }
            } else {
              alert(responseMaterial.data.Message);
              currentIndex = this.MaterialObjectData.length - 1;
              nextIndex = this.MaterialObjectData.length - 1;
              prevIndex = currentIndex - 1;
            }
          } else {
            currentIndex = this.MaterialObjectData.length - 1;
            nextIndex = this.MaterialObjectData.length - 1;
            prevIndex = currentIndex - 1;
          }
        }

        try {
          this.visibleImage = currentIndex;
          this.prevMaterialFileType = this.MaterialFileType;
          this.prevMaterialFileName = this.MaterialFileName;
          this.prevMaterialFileUrl = this.MaterialFileUrl;
          this.prevMaterialUnitPageId = this.MaterialUnitPageId;
          this.prevMaterialUnit = this.MaterialUnit;
          this.prevMaterialUnitPage = this.MaterialUnitPage;
          this.prevMaterialCode = this.MaterialCode;

          this.MaterialFileType =
            this.MaterialObjectData[currentIndex].FileType;
          this.MaterialFileName =
            this.MaterialObjectData[currentIndex].FileName;
          this.MaterialFileUrl = this.MaterialObjectData[currentIndex].FileUrl;
          this.MaterialUnitPageId =
            this.MaterialObjectData[currentIndex].MaterialUnitPageId;
          this.MaterialUnit =
            this.MaterialObjectData[currentIndex].MaterialUnit;
          this.MaterialUnitPage =
            this.MaterialObjectData[currentIndex].MaterialPage;
          this.MaterialCode =
            this.MaterialObjectData[currentIndex].MaterialCode;

          var imgTemp = document.querySelector("#obj-" + currentIndex);

          // this.SELECTIMGWIDTH = imgTemp.children[0].naturalWidth;
          // this.SELECTIMGHEIGHT = imgTemp.children[0].naturalHeight;
          this.SELECTIMGWIDTH = imgTemp.children[0].naturalWidth;
          this.SELECTIMGHEIGHT = imgTemp.children[0].naturalHeight;
        } catch (error) {}

        var img = this.MaterialObjectData[currentIndex].FileUrl;

        // 同步 EnglishFileName
        this.EnglishFileName = this.MaterialCode === "NewPage"
          ? "New" + this.MaterialFileName : this.MaterialFileName;
        this.ChineseFileName = this.MaterialFileName;

        // 构造 fileData 供 socket emit 使用
        var fileData = `${this.roomId}|${this.MaterialUnitPageId}|${this.MaterialUnit}|${this.MaterialUnitPage}|${this.EnglishFileName}|${this.MaterialName}`;

        // 检查是否 NewPage 并设置画布
        if (this.MaterialCode === "NewPage") {
          type = "new";
          this.setupCanvasAndResizeElements("100%", "100%");
        }

        // 直接用确定性参数加载，传入 fallbackImg 回退到教材背景图
        this.loadJsonFromDatabase(
          this.roomId, this.EnglishFileName,
          this.MaterialUnit, this.MaterialUnitPage, type,
          img, this.imgTempId
        );

        this.versions = 0;
        this.fileUrl = this.currentBackgroundImage;
        this.prevIndexGlobal = prevIndex;
        this.nextIndexGlobal = nextIndex;
        this.currentIndexGlobal = currentIndex;
        this.mediaProgressNum = this.currentIndexGlobal + 1;
        this.socket.emit("setImgTempId", {
          roomId: String(this.roomId),
          status: "next",
          type: type,
          num: [
            this.prevIndexGlobal,
            this.nextIndexGlobal,
            this.currentIndexGlobal,
            this.mediaProgressNum,
          ],
          file: fileData,
        });

        if (this.MaterialObjectData.length > 0) {
          //Send Image to Hitutor Old Function
          // var originalTransform = this.fabricObj.viewportTransform;
          // this.fabricObj.viewportTransform = fabric.iMatrix.slice(0);
          // let base64URl = this.fabricObj.toDataURL({
          //   format: "image/jpg",
          //   multiplier: 1,
          // });
          // this.fabricObj.viewportTransform = originalTransform;

          // this.imageBase64 = base64URl;

          if (
            this.prevMaterialFileType !== "" &&
            this.prevMaterialFileName !== "" &&
            this.prevMaterialFileUrl !== "" &&
            this.prevMaterialUnitPageId !== "" &&
            this.prevMaterialUnit !== "" &&
            this.prevMaterialUnitPage !== "" &&
            this.prevMaterialCode !== "" &&
            this.prevMaterialFileType !== undefined &&
            this.prevMaterialFileName !== undefined &&
            this.prevMaterialFileUrl !== undefined &&
            this.prevMaterialUnitPageId !== undefined &&
            this.prevMaterialUnit !== undefined &&
            this.prevMaterialUnitPage !== undefined &&
            this.prevMaterialCode !== undefined &&
            this.prevMaterialFileType !== null &&
            this.prevMaterialFileName !== null &&
            this.prevMaterialFileUrl !== null &&
            this.prevMaterialUnitPageId !== null &&
            this.prevMaterialUnit !== null &&
            this.prevMaterialUnitPage !== null &&
            this.prevMaterialCode !== null
          ) {
            // this.uploadTeacherMedia();
          }
        }

        // var evt = new MouseEvent("mousedown", {
        //     clientX: 15,
        //     clientY: 15
        // });
        // this.fabricObj.upperCanvasEl.dispatchEvent(evt);

        // var evt = new MouseEvent("mouseup", {
        //     clientX: 15,
        //     clientY: 15
        // });
        // this.fabricObj.upperCanvasEl.dispatchEvent(evt);

        // this.fabricObj.clear();
      }
    },

    async setBackgroundDynamic4(imgUrl, imgTempId, type) {
      var valueIndex = {
        prevIndexGlobal: this.prevIndexGlobal,
        nextIndexGlobal: this.nextIndexGlobal,
        currentIndexGlobal: this.currentIndexGlobal,
      };
      if (type != "firstLoad") {
        whiteboard.clearWhiteboard();
        var base64 = await this.imageUrlToBase64(String(imgUrl));
        this.uploadImgSetToWhiteboard(base64);
      } else {
        whiteboard.setImgAsBackgroundByUrl(
          String(imgUrl),
          imgTempId,
          valueIndex,
          true
        );
      }

      signaling_socket.emit("updateIndex", valueIndex);
    },

    setBackgroundDynamic(imgUrl) {
      this.fabricObj.setBackgroundImage(
        imgUrl,
        this.fabricObj.renderAll.bind(this.fabricObj),
        {
          backgroundImageOpacity: 1,
          // should the image be resized to fit the container?
          backgroundImageStretch: true,
          crossOrigin: "anonymous",
        }
      );
      this.fabricObj.setWidth(this.SELECTIMGWIDTH);
      this.fabricObj.setHeight(this.SELECTIMGHEIGHT);
    },

    setBackgroundDynamic3(imgUrl) {
      var widthz = $(".book_scroll").width();
      this.fabricObj.setBackgroundImage(
        imgUrl,
        this.fabricObj.renderAll.bind(this.fabricObj),
        {
          scaleX: widthz / this.SELECTIMGWIDTH,
          scaleY: widthz / this.SELECTIMGWIDTH,
          // width: window.innerWidth,
          //height: window.innerHeight,
          // Optionally add an opacity lvl to the image
          backgroundImageOpacity: 1,
          // should the image be resized to fit the container?
          backgroundImageStretch: true,
          crossOrigin: "anonymous",
        }
      );
      this.backgroundState = 3;
      this.widthFabric = this.SELECTIMGWIDTH * (widthz / this.SELECTIMGWIDTH);
      this.heightFabric = this.SELECTIMGHEIGHT * (widthz / this.SELECTIMGWIDTH);

      this.fabricObj.setWidth(this.widthFabric);
      this.fabricObj.setHeight(this.heightFabric);
    },

    //this is called the non hitutor image
    setBackgroundDynamic2(imgUrl) {
      var widthz = $(".book_scroll").width();
      this.fabricObj.setBackgroundImage(
        imgUrl,
        this.fabricObj.renderAll.bind(this.fabricObj),
        {
          // scaleX: widthz/this.SELECTIMGWIDTH,
          // scaleY: widthz/this.SELECTIMGWIDTH,
          // scaleX: 0.55,
          // scaleY: 0.55,
          // width: window.innerWidth,
          //height: window.innerHeight,
          // Optionally add an opacity lvl to the image
          backgroundImageOpacity: 1,
          // should the image be resized to fit the container?
          backgroundImageStretch: true,
          crossOrigin: "anonymous",
        }
      );
      this.backgroundState = 2;
      this.widthFabric = this.SELECTIMGWIDTH * (widthz / this.SELECTIMGWIDTH);
      this.heightFabric = this.SELECTIMGHEIGHT * (widthz / this.SELECTIMGWIDTH);

      this.fabricObj.setWidth(this.widthFabric);
      this.fabricObj.setHeight(this.heightFabric);
    },
    //--------------------------------------//

    //-------------UploadImage--------------//
    selectImage(event, materialData, currentIndex, prevIndex, nextIndex) {
      this.saveAsImageBtn();

      for (let i = 0; i < this.MaterialObjectData.length; i++) {
        var elem = "obj-" + i;
        if (i !== this.currentIndex) {
          if (document.getElementById(elem)) {
            var element = document.getElementById(elem).firstChild;
            element.style.removeProperty("border");
          }
        }
      }

      if (this.MaterialObjectData.length > 0) {
        $(".book_scroll").animate({ scrollTop: "0px" }, 1000);
        var img = document.querySelector("#img-" + currentIndex).src;
        this.imgTempId = "obj-" + currentIndex;
        // var img=event.path[0].src;
        if (prevIndex < 0) {
          prevIndex = 0;
        }

        if (nextIndex > this.MaterialObjectData.length - 1) {
          nextIndex = this.MaterialObjectData.length - 1;
        }

        this.prevIndexGlobal = prevIndex;
        this.nextIndexGlobal = nextIndex;
        this.currentIndexGlobal = currentIndex;
        this.visibleImage = currentIndex;

        try {
          this.SELECTIMGWIDTH = document.querySelector(
            "#img-" + currentIndex
          ).naturalWidth;
          this.SELECTIMGHEIGHT = document.querySelector(
            "#img-" + currentIndex
          ).naturalHeight;
        } catch (error) {}

        this.MaterialFileType = materialData.FileType;
        this.MaterialFileName = materialData.FileName;
        this.MaterialFileUrl = materialData.FileUrl;
        this.MaterialUnitPageId = materialData.MaterialUnitPageId;
        this.MaterialUnit = materialData.MaterialUnit;
        this.MaterialUnitPage = materialData.MaterialPage;
        this.MaterialCode = materialData.MaterialCode;

        let paramFileName =
          this.roomId +
          this.MaterialUnitPageId +
          this.MaterialUnit +
          this.MaterialUnitPage +
          this.MaterialFileName;

        this.currentSelectedImage = paramFileName;

        this.$axios
          .get(`/materialmodel/detailsbyEnglishName/` + paramFileName)
          .then((response) => {
            if (
              response.data.payload.materialObject != null ||
              response.data.payload.materialObject != undefined
            ) {
              var classID = response.data.payload.materialObject.classRoomID;
              var fileURL =
                response.data.payload.materialObject.fileName.split(".")[0] +
                ".jpg";
              var imgUrl =
                process.env.BASE_URL +
                "/materialmodel/img/" +
                classID +
                "/" +
                fileURL;
              this.setBackgroundDynamic4(imgUrl, this.imgTempId);
              this.currentBackgroundImage = imgUrl;
            } else {
              this.setBackgroundDynamic4(img, this.imgTempId);
              this.currentBackgroundImage = img;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      signaling_socket.emit("setImgTempId", "selectImage");
    },
    uploadAsImageBtn() {
      whiteboard.getImageDataBase64(
        {
          imageFormat: ConfigService.imageDownloadFormat,
          drawBackgroundGrid: true,
        },
        function (imgData) {
          var w = window.open("about:blank"); //Firefox will not allow downloads without extra window
          setTimeout(function () {
            //FireFox seems to require a setTimeout for this to work.
            var a = document.createElement("a");
            a.href = imgData;
            a.download = "whiteboard." + ConfigService.imageDownloadFormat;
            w.document.body.appendChild(a);
            a.click();
            w.document.body.removeChild(a);
            setTimeout(function () {
              w.close();
            }, 100);
          }, 0);
        }
      );
    },
    uploadAsJSONBtn() {
      var imgData = whiteboard.getImageDataJson();

      var w = window.open("about:blank"); //Firefox will not allow downloads without extra window
      setTimeout(function () {
        //FireFox seems to require a setTimeout for this to work.
        var a = document.createElement("a");
        a.href = window.URL.createObjectURL(
          new Blob([imgData], { type: "text/json" })
        );
        a.download = "whiteboard.json";
        w.document.body.appendChild(a);
        a.click();
        w.document.body.removeChild(a);
        setTimeout(function () {
          w.close();
        }, 100);
      }, 0);
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    downloadImage() {
      this.done = true;
      let base64URl = this.fabricObj.toDataURL({
        format: "png",
        multiplier: 4,
      });
      this.imageBase64 = base64URl;
      this.done = false;
      const a = document.createElement("a");
      a.href = base64URl;
      a.download = "joke";
      a.click();
    },
    async isBase64UrlImage(base64String) {
      let image = new Image();
      image.src = base64String;
      return await new Promise((resolve) => {
        image.onload = function () {
          if (image.height === 0 || image.width === 0) {
            resolve(false);
            return;
          }
          resolve(true);
        };
        image.onerror = () => {
          resolve(false);
        };
      });
    },

    async uploadTeacherMedia() {
      var checkIsImage = await this.isBase64UrlImage(this.imageBase64);
      if (checkIsImage && this.fileUrl != undefined && this.fileUrl != "") {
        this.isLoading = true;
        this.$store.dispatch("uploadTeacherMedia", {
          classRoomID: this.$store.state.classRoomId,
          materialCode: this.prevMaterialCode,
          materialUnit: this.prevMaterialUnit,
          materialPage: this.prevMaterialUnitPage,
          MaterialFileName: this.prevMaterialFileName,
          base64Img: this.imageBase64,
          fileUrl: this.fileUrl,
          englishName: this.prevMaterialFileName,
          chineseName: this.prevMaterialFileName,
          version: 3,
        });
      }
    },
    waitForElement(selector, callback) {
      selector.forEach((s) => {
        const element = document.querySelector(s);

        if (element) {
          callback(element);
        } else {
          const observer = new MutationObserver((mutationList) => {
            mutationList.forEach((mutation) => {
              if (
                [mutation.target, ...mutation.addedNodes].some(
                  (node) => node.matches && node.matches(s)
                )
              ) {
                const element = document.querySelector(s);
                callback(element);
                observer.disconnect();
              }
            });
          });
          observer.observe(document.body, { childList: true, subtree: true });
        }
      });
    },
    waitForElementsToLoad(selectors, callback) {
      const elementsNeeded = selectors.length;
      let elementsFound = 0;
      const elements = new Map();

      // Create a new MutationObserver instance
      const observer = new MutationObserver((mutations, obs) => {
        selectors.forEach((selector) => {
          if (!elements.has(selector)) {
            const element = document.querySelector(selector);
            if (element) {
              elements.set(selector, element);
              elementsFound++;
            }
          }
        });

        // Check if all elements are found
        if (elementsFound === elementsNeeded) {
          // If all elements are found, disconnect the observer and run the callback
          obs.disconnect();
          callback();
        }
      });

      // Start observing the document for changes to the DOM
      observer.observe(document.body, {
        childList: true, // Watch for additions/removals of child nodes
        subtree: true, // Watch the entire subtree of the document
      });

      // Initial check in case elements are already in the DOM
      selectors.forEach((selector) => {
        const element = document.querySelector(selector);
        if (element) {
          elements.set(selector, element);
          elementsFound++;
        }
      });

      // If all elements are already found, run the callback immediately
      if (elementsFound === elementsNeeded) {
        observer.disconnect();
        callback();
      }
    },
    async loadImgMaterial() {
      if (this.currentIndexMaterial >= 0) {
        if (!this.MaterialObjectData || !this.MaterialObjectData[this.currentIndexMaterial]) {
          // 教材資料尚未就緒，等待 MaterialObjectData 填充後再重試
          var unwatch = this.$watch(
            () => this.MaterialObjectData,
            (val) => {
              if (val && val[this.currentIndexMaterial]) {
                unwatch();
                this.loadImgMaterial();
              }
            },
            { deep: false }
          );
          return;
        }
        this.MaterialFileType =
          this.MaterialObjectData[this.currentIndexMaterial].FileType;
        this.MaterialFileName =
          this.MaterialObjectData[this.currentIndexMaterial].FileName;
        this.MaterialName =
          this.MaterialObjectData[this.currentIndexMaterial].MaterialName;
        this.MaterialFileUrl =
          this.MaterialObjectData[this.currentIndexMaterial].FileUrl;
        this.MaterialUnitPageId =
          this.MaterialObjectData[this.currentIndexMaterial].MaterialUnitPageId;
        this.MaterialUnit =
          this.MaterialObjectData[this.currentIndexMaterial].MaterialUnit;
        this.MaterialUnitPage =
          this.MaterialObjectData[this.currentIndexMaterial].MaterialPage;
        this.MaterialCode =
          this.MaterialObjectData[this.currentIndexMaterial].MaterialCode;

        var imgTemp = document.querySelector(
          "#obj-" + this.currentIndexMaterial
        );

        this.imgTempId = "obj-" + this.currentIndexMaterial;
        var type = "firstLoad";

        var img = this.MaterialObjectData[this.currentIndexMaterial].FileUrl;
        var materialCode = this.MaterialObjectData[this.currentIndexMaterial].MaterialCode;
        console.log("firstLoad", this.roomId, this.MaterialFileName, this.MaterialUnit, this.MaterialUnitPage);

        // 判斷是否為插入的空白板頁（NewPage），空白頁沒有背景圖片
        var isBlankPage = materialCode === "NewPage" || !img;

        // 1. 設定背景圖（空白頁則清除舊背景，普通教材頁則載入圖片）
        if (isBlankPage) {
          whiteboard.loadCurrentData([{t: "clear"}], false);
          this.currentBackgroundImage = "";
        } else {
          this.setBackgroundDynamic4(img, this.imgTempId, type);
          this.currentBackgroundImage = img;
        }

        // 2. 然后尝试加载 JSON 绘图数据叠加到背景上
        // NewPage 插入頁的 JSON 以 "New" + FileName 為 key 儲存（與老師端 nextPicture 邏輯一致）
        var safeName = (this.MaterialCode === "NewPage"
          ? "New" + (this.MaterialFileName || "") : (this.MaterialFileName || "")) || "none";
        var safeUnit = this.MaterialUnit || "none";
        var safePage = this.MaterialUnitPage || "none";
        try {
          const response = await this.$axios.get(
            `/materialmodel/json/load/${encodeURIComponent(this.roomId)}/${encodeURIComponent(safeName)}/${encodeURIComponent(safeUnit)}/${encodeURIComponent(safePage)}`
          );
          if (response.data && Array.isArray(response.data) && response.data.length > 0) {
            whiteboard.loadJsonData(response.data, true, () => {
              // 先清除已加載的 DB JSON 筆跡，避免與 live buffer 重複疊加
              var strokesOnly = (this.content || []).filter(item => item && item["t"] !== "addImgContentAsBG" && item["t"] !== "clear");
              if (strokesOnly.length > 0) {
                whiteboard.loadCurrentData([{t: "clearDrawing"}, ...strokesOnly], false);
              }
              if (
                this.zoom == 1 &&
                $("#ContextImgAsBackground").height() <
                  $("#whiteboardContainer").height()
              ) {
                const transform = `translate(0px, -50%)`;
                const position = { transform: transform, top: "50%" };
                $(
                  "#whiteboardCanvas, #imgContainer, #backgroundGrid, #svgContainer, #dropIndicator, #cursorContainer, #textContainer, #mouseOverlay"
                ).css(position);
              }
              if (!this.imageExists(response.data)) {
                $("#loadingMedia").css({ display: "none" });
                $("#loadingMedia").css({ zIndex: "0" });
              }
            });
          }
        } catch (error) {
          // 已设了背景图，无需额外操作
          console.log("firstLoad: 此页无绘图数据", error?.response?.status);
        }

        this.currentBackgroundImage = img;
        this.prevIndexGlobal = this.currentIndexMaterial - 1;
        this.nextIndexGlobal = this.currentIndexMaterial + 1;
        this.currentIndexGlobal = this.currentIndexMaterial;
        this.mediaProgressNum = this.currentIndexGlobal + 1;
      }
    },
    retrieveChats() {
      this.socket.emit("retrieveChats", {
        roomId: String(this.roomId),
      });
    },
    pushChatMessage(msg) {
      this.socket.emit("push-chat-message", {
        roomId: String(this.roomId),
        msg,
      });
    },
    setPermissionsStudent(state) {
      this.student_drawing_permissions = state;
      this.$emit("student_drawing_permissions", state);
    },
    updateGroupLabels() {
      const selectComponent = this.$refs.selectComponent;
      if (selectComponent) {
        const groups = selectComponent.$el.querySelectorAll(
          ".el-select-group__title"
        );
        this.fileSelectList.forEach((group, index) => {
          const groupTitle = groups[index];
          console.log("updateGroupLabels", group);
          if (groupTitle) {
            groupTitle.innerHTML = `<img src="${group.imgUrl}" alt="Group Image" style="width: 20px; height: auto;"/>`;
          }
        });
      }
    },
    setTimerRun() {
      this.socket.emit("setTimerRun", {
        roomId: String(this.roomId),
      });
    },
    screenEntryClose() {
      this.screenEntry = !this.screenEntry;
    },
    resetScrollbar(){
      const container = this.$refs.whiteboardContainer
      if (container) {
        container.scrollTop = 0
        container.scrollLeft = 0
        this.thumbTop = 0
        this.thumbLeft = 0
      }
    },
    updateScrollbarThumb() {
      const scrollContainer = this.$refs.whiteboardContainer;
      const thumb = this.$refs.customScrollbar;

      const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
      const thumbHeight = (clientHeight / scrollHeight) * clientHeight;
      const thumbTop = (scrollTop / (scrollHeight - clientHeight)) * (clientHeight - thumbHeight);

      thumb.style.height = `${thumbHeight}px`;
      thumb.style.top = `${thumbTop}px`;
    },
    updateThumb() {
      const container = this.$refs.whiteboardContainer;
      const canvas = container?.querySelector("#whiteboardCanvas");

      if (!container || !canvas) {
        console.warn("Missing container or canvas in updateThumb()");
        return;
      }

      const visibleHeight = container.clientHeight;
      const visibleWidth = container.clientWidth;

      const canvasHeight = canvas.clientHeight;
      const canvasWidth = canvas.clientWidth;

      const contentHeight = canvasHeight * this.zoom;
      const contentWidth = canvasWidth * this.zoom;

      this.scrollbarHeight = visibleHeight;
      this.scrollbarWidth = visibleWidth;

      const thumbHeightRaw = visibleHeight * (visibleHeight / contentHeight);
      const thumbWidthRaw = visibleWidth * (visibleWidth / contentWidth);

      this.thumbHeight = isFinite(thumbHeightRaw) ? Math.max(thumbHeightRaw, 30) : 30;
      this.thumbWidth = isFinite(thumbWidthRaw) ? Math.max(thumbWidthRaw, 30) : 30;

      this.$refs.customScrollbar.style.display = contentHeight <= visibleHeight ? "none" : "block";
      this.$refs.customScrollbarHorizontal.style.display = contentWidth <= visibleWidth ? "none" : "block";

      if (contentWidth <= visibleWidth) {
        this.thumbLeft = 0;
      } else if (!isFinite(this.thumbLeft)) {
        this.thumbLeft = 0; // fallback
      }

      if (contentHeight <= visibleHeight) {
        this.thumbTop = 0;
      }

      $("#loadingMedia").css({
          display: "none",
      });
      $("#loadingMedia").css({ zIndex: "0" });
    },
    handleScroll() {
      const container = this.$refs.whiteboardContainer;
      const scrollbar = this.$refs.customScrollbar;
      const scrollbarx = this.$refs.customScrollbarHorizontal;

      const scrollRatio =
        container.scrollTop / (container.scrollHeight - container.clientHeight);
      const scrollxRatio =
        container.scrollLeft / (container.scrollWidth - container.clientWidth);
      this.thumbTop = scrollRatio * (scrollbar.clientHeight - this.thumbHeight);
      this.thumbLeft =
        scrollxRatio * (scrollbarx.clientWidth - this.thumbWidth);
    },
    startDrag(e) {
      this.isDragging = true;
      this.startY = e.touches ? e.touches[0].clientY : e.clientY;
      this.startScrollTop = this.$refs.whiteboardContainer.scrollTop;
      this.startThumbTop = this.thumbTop;
      
      if (e.cancelable) e.preventDefault();

      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
      document.addEventListener("touchmove", this.onDrag, { passive: false });
      document.addEventListener("touchend", this.stopDrag);
    },
    onDrag(e) {
      if (!this.isDragging) return;
      const clientY = e.touches ? e.touches[0].clientY : e.clientY;
      const deltaY = clientY - this.startY;

      const container = this.$refs.whiteboardContainer;
      const scrollbar = this.$refs.customScrollbar;

      const maxScrollTop = container.scrollHeight - container.clientHeight;
      const maxThumbTop = scrollbar.clientHeight - this.thumbHeight;
      const scrollRatio = maxScrollTop / maxThumbTop;
      let newThumbTop = this.startThumbTop + deltaY

      newThumbTop = Math.max(0, Math.min(newThumbTop, maxThumbTop));
      this.thumbTop = newThumbTop;
      container.scrollTop = newThumbTop * scrollRatio;
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
      document.removeEventListener("touchmove", this.onDrag, { passive: false });
      document.removeEventListener("touchend", this.stopDrag, { passive: false });
    },
    startHorizontalDrag(e) {
      this.isDraggingHorizontal = true;
      this.startX = e.touches ? e.touches[0].clientX : e.clientX;
      this.startScrollLeft = this.$refs.whiteboardContainer.scrollLeft;
      this.startThumbLeft = this.thumbLeft;

      if (e.cancelable) e.preventDefault();

      document.addEventListener("mousemove", this.onHorizontalDrag);
      document.addEventListener("mouseup", this.stopHorizontalDrag);
      document.addEventListener("touchmove", this.onHorizontalDrag, { passive: false });
      document.addEventListener("touchend", this.stopHorizontalDrag, { passive: false });
    },
    onHorizontalDrag(e) {
      if (!this.isDraggingHorizontal) return;

      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const deltaX = clientX - this.startX;

      const container = this.$refs.whiteboardContainer;
      const scrollbar = this.$refs.customScrollbarHorizontal;

      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      const maxThumbLeft = scrollbar.clientWidth - this.thumbWidth;

      const scrollRatio = maxScrollLeft / maxThumbLeft;
      let newThumbLeft = this.startThumbLeft + deltaX;

      newThumbLeft = Math.max(0, Math.min(newThumbLeft, maxThumbLeft));
      this.thumbLeft = newThumbLeft;
      container.scrollLeft = newThumbLeft * scrollRatio;
    },
    stopHorizontalDrag() {
      this.isDraggingHorizontal = false;
      document.removeEventListener("mousemove", this.onHorizontalDrag);
      document.removeEventListener("mouseup", this.stopHorizontalDrag);
      document.removeEventListener("touchmove", this.onHorizontalDrag, { passive: false });
      document.removeEventListener("touchend", this.stopHorizontalDrag, { passive: false });
    },
    ...mapMutations(["SET_DRAWING_PERMISSIONS_STUDENT"]),
    //--------------------------------------//
  },
  async mounted() {
    this._unlockAudio = () => {
      if (this.audioCtx && this.audioCtx.state === "suspended") {
        this.audioCtx.resume().catch(() => {});
      }
    };
    document.addEventListener("touchstart", this._unlockAudio, { passive: true });
    document.addEventListener("click", this._unlockAudio, { passive: true });

    let mainUIUXScript = document.createElement("script");
    mainUIUXScript.setAttribute("src", "/static/main.js");
    document.head.appendChild(mainUIUXScript);

    this.userIdz = this.$store.state.UserId;
    this.teachername = this.$store.state.TeacherName;
    this.roomId = sessionStorage.getItem("classroomId");
    this.userId = sessionStorage.getItem("userId");
    this.userName = sessionStorage.getItem("userName");
    this.userType = sessionStorage.getItem("userType");
    this.is_teacher = this.$store.state.teacher;
    this.onlineUsers = this.$store.state.onlineUsers;
    this.beginTimeStamp = moment
      .unix(this.$store.state.BeginTimeStamp)
      .format("LLLL");

    if (
      this.$store.state.MaterialVedioObject.length > 0 &&
      this.$store.state.MaterialVedioObject[0] != undefined
    ) {
      this.mediaVedioSelected =
        this.$store.state.MaterialVedioObject[0].FileUrl;
    }

    $("#whiteboardColorpicker").css({ background: this.paletteBackground });
    if (randomid) {
      whiteboardId = uuidv4();
      urlParams.delete("randomid");
      window.location.search = urlParams;
    }

    if (!whiteboardId) {
      whiteboardId = this.roomId;
    }

    this.myUsername =
      urlParams.get("username") ||
      "unknown" + (Math.random() + "").substring(2, 6);
    this.accessToken = urlParams.get("accesstoken") || "";
    this.copyfromwid = urlParams.get("copyfromwid") || "";

    this.title = urlParams.get("title");
    if (this.title) {
      document.title = decodeURIComponent(title);
    }

    this.subdir = "";
    try {
      signaling_socket = io(`${process.env.VUE_APP_WHITEBOARD_SERVICE_URL || process.env.VUE_APP_WHITEBOARD_URL}`, {
        path: this.subdir + "/ws-api",
      }); // Connect even if we are in a subdir behind a reverse proxy
      // signaling_socket = io("", { path: this.subdir + "/ws-api" });
    } catch (error) {
      alert(error);
    }

    signaling_socket.on("connect", () => {
      console.log("Websocket connected!");

      signaling_socket.on("whiteboardConfig", (serverResponse) => {
        ConfigService.initFromServer(serverResponse);
        // Inti whiteboard only when we have the config from the server
        $(document).ready(() => {
          this.initWhiteBoard();
        });
      });

      signaling_socket.on("whiteboardInfoUpdate", (info) => {
        InfoService.updateInfoFromServer(info);
        whiteboard.updateSmallestScreenResolution();
      });

      signaling_socket.on("drawToWhiteboard", function (content) {
        whiteboard.drawToWhiteboardRemote(content, true);
        InfoService.incrementNbMessagesReceived();
      });

      signaling_socket.on("refreshUserBadges", function () {
        whiteboard.refreshUserBadges();
      });

      let accessDenied = false;
      signaling_socket.on("wrongAccessToken", () => {
        if (!accessDenied) {
          accessDenied = true;
          this.showBasicAlert("Access denied! Wrong accessToken!");
        }
      });

      signaling_socket.on("updateIndexGlobal", (data) => {
        this.prevIndexGlobal = data.prevIndexGlobal;
        this.nextIndexGlobal = data.nextIndexGlobal;
        this.currentIndexGlobal = data.currentIndexGlobal;
      });

      signaling_socket.on("getImgTempId", (data) => {
        this.prevIndexGlobal = data.num[0];
        this.nextIndexGlobal = data.num[1];
        this.currentIndexGlobal = data.num[2];
        this.mediaProgressNum = data.num[3];

        $("#loadingMedia").removeAttr("style");
        $("#loadingMedia").css({ zIndex: "1" });
        $("#ContextImgAsBackground").on("load", () => {
          $("#loadingMedia").css({
            display: "none",
          });
          $("#loadingMedia").css({ zIndex: "0" });
        });
      });

      signaling_socket.on("getSavedData", (data) => {
        this.content = data;
      });

      signaling_socket.emit("joinWhiteboard", {
        wid: whiteboardId,
        at: this.accessToken,
        windowWidthHeight: { w: $(window).width(), h: $(window).height() },
      });
    });

    await this.loadData();
    var elementList = [
      "#mouseOverlay",
      "#backgroundGrid",
      "#whiteboardCanvas",
      "#imgContainer",
    ];
    this.waitForElementsToLoad(elementList, async () => {
      await this.initializeSocket();
      const whiteboardCanvas =
        this.$refs.whiteboardContainer.querySelector("#whiteboardCanvas");
      if (whiteboardCanvas) {
        this.resizeObserver = new ResizeObserver(this.updateThumb);
        this.resizeObserver.observe(whiteboardCanvas);
      }

      $('#textContainer, #mouseOverlay').css('pointer-events', 'none');
    });

    this.$nextTick(() => {
      this.$refs.video.addEventListener("loadedmetadata", this.setDuration);
      this.$refs.audio.addEventListener("loadedmetadata", this.setupSlider);
    
      const container = document.getElementById("whiteboardContainer");
      const canvas = document.getElementById("whiteboardCanvas");

      let lastTouch = null;

      container.addEventListener(
        "touchstart",
        (e) => {
          if (e.touches.length >= 2) {
            lastTouch = {
              x: e.touches[0].clientX,
              y: e.touches[0].clientY,
            };
          }
        },
        { passive: false }
      );

      container.addEventListener(
        "touchmove",
        (e) => {
          if (e.touches.length >= 2 && lastTouch) {
            e.preventDefault();
            const currentTouch = e.touches[0];

            const deltaX = lastTouch.x - currentTouch.clientX;
            const deltaY = lastTouch.y - currentTouch.clientY;

            container.scrollLeft += deltaX;
            container.scrollTop += deltaY;

            lastTouch = {
              x: currentTouch.clientX,
              y: currentTouch.clientY,
            };
          }
        },
        { passive: false }
      );

      container.addEventListener("touchend", () => {
        lastTouch = null;
      });

      this.$refs.whiteboardContainer.addEventListener(
        "scroll",
        this.handleScroll
      );

      this.$refs.scrollbarThumb.addEventListener("touchstart", this.startDrag, {
        passive: false
      });

      this.$refs.scrollbarThumbHorizontal.addEventListener("touchstart", this.startHorizontalDrag, {
        passive: false
      });
    });

    this.$watch(
      () => this.$store.state.MaterialVedioObject,
      () => {
        this.getMaterialVedioObjectData();
      }
    );

    this.$watch(
      () => this.$store.state.MaterialMediaObject,
      () => {
        this.getMaterialMediaObjectData();
      }
    );

    this.$watch(
      () => this.$store.state.MaterialObject,
      () => {
        this.getMaterialObjectData();

        if (this.newMaterial.length > 0) {
          this.MaterialObjectData.splice(
            data[0].currentIndexGlobal,
            0,
            data[0].newMaterial
          );
          console.log("NewMaterial", this.MaterialObjectData);
        }
        this.loadImgMaterial();
      }
    );

    window.addEventListener("resize", () => {
      this.resetScrollbar()
      this.zoom = 1;
      // this.updateThumb()
    });

    if (!this.employee_full_status) {
      $(".employee-box").removeAttr("style");
      $("#router").removeAttr("style");
    } else {
      $(".employee-box").css({ padding: "0px 100px" });
      $("#router").css({ height: "100%", width: "100%" });
    }
  },
};
</script>

<style lang="scss" scoped>
.sketchpad {
  width: 100%;
  height: 100%;

  .sketchpad-head {
    z-index: 2;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .sketchpad-head-left {
      display: flex;
      align-items: center;

      p {
        color: #1f2937;
        font-size: 12px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }

      img {
        margin: 0 12px 0 6px;
        width: 12px;
        height: 12px;
      }

      span {
        color: #6b7280;
        font-size: 12px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
    }
  }

  .sketchpad-box {
    width: 100%;
    height: calc(100% - 40px);
    display: flex;
    justify-content: space-between;

    .sketchpad-box-left {
      padding: 15px 10px;
      width: 60px;
      max-height: 100%;
      overflow: auto;
      border-radius: 8px;
      border: 1px solid #e9e9ea;
      background: #fff;
      /*position: relative; */
      scrollbar-width: none;
      /* Firefox */
      -ms-overflow-style: none;

      /* IE10+ */
      &::-webkit-scrollbar {
        display: none;
        /* ChromeSafari */
      }

      .sketchpad-box-left-mask {
        cursor: no-drop;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background: rgba($color: #fff, $alpha: 0.7);
      }

      .left-box {
        margin-bottom: 16px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .sketchpad-box-right {
      width: calc(100% - 76px);
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-content: space-between;
      position: relative;
      flex-direction: row;

      .sketchpad-box-right-head {
        width: 100%;
        height: calc(100% - 58px);
        border-radius: 8px;
        border: 1px solid #e9e9ea;
        background: #fff;
      }

      .sketchpad-box-right-foo {
        padding: 0 12px;
        width: 100%;
        height: 50px;
        border-radius: 8px;
        border: 1px solid #e9e9ea;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .foo-left {
          display: flex;
          align-items: center;
          flex: 1;
          min-width: 0;
          overflow: hidden;

          .foo-left-box {
            cursor: pointer;
            user-select: none;
            width: 40px;
            height: 40px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background: #f3f4f6;
            }

            img {
              width: 16px;
              height: 16px;
            }
          }

          .foo-left-music {
            cursor: pointer;
            user-select: none;
            width: 40px;
            height: 40px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              width: 16px;
              height: 16px;
            }
          }

          .foo-left-div {
            margin: 0 5px;
            min-width: 40px;
            color: #000;
            font-size: 13px;
            font-family: Microsoft JhengHei;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
          }

          .foo-left-select {
            flex: 0 1 180px;
            min-width: 80px;
            height: 30px;
            border-radius: 4px;
            position: relative;

            ::v-deep .el-select {
              width: 100%;
              height: 100%;

              .el-input {
                width: 100%;
                height: 100%;

                .el-input__inner {
                  padding: 5px 34px 5px 14px;
                  width: 100%;
                  height: 100%;
                  border: 1px solid rgba(0, 0, 0, 0.2);
                  color: #323130;
                  font-size: 12px;
                  font-family: Microsoft JhengHei;
                  font-style: normal;
                  font-weight: 400;
                  line-height: normal;
                }

                .el-input__suffix {
                  display: none;
                }
              }
            }

            .foo-left-select-div {
              position: absolute;
              top: 5px;
              right: 10px;
              width: 20px;
              height: 20px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .foo-right {
          display: flex;
          align-items: center;
          flex-shrink: 0;

          .foo-media {
            display: flex;
            align-items: center;

            .foo-media-btn {
              user-select: none;
              cursor: no-drop;
              width: 40px;
              height: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 5px;

              &:hover {
                background: #f2f2f2;
              }

              img {
                width: 24px;
                height: 24px;
              }
            }

            .foo-media-time {
              margin: 0 5px;
              color: #000;
              font-size: 14px;
              font-family: Microsoft JhengHei;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }

            .foo-media-slider {
              margin: 0 20px;
              width: 246px;
            }
          }

          .foo-volume {
            margin: 0 50px;
            display: flex;
            align-items: center;

            .volume-btn {
              cursor: pointer;
              user-select: none;
              width: 40px;
              height: 40px;
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: center;

              &:hover {
                background: #f3f4f6;
              }

              img {
                width: 24px;
                height: 24px;
              }

              span {
                width: 24px;
                height: 24px;
              }
            }

            .volume-slider {
              margin-left: 10px;
              width: 130px;
            }
          }

          .foo-full {
            cursor: pointer;
            user-select: none;
            width: 40px;
            height: 40px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              background: #f3f4f6;
            }

            img {
              width: 24px;
              height: 24px;
            }
          }
        }

        @media screen and (max-width: 1880px) {
          .foo-right {
            .foo-media {
              .foo-media-slider {
                margin: 0 15px;
                width: 180px;
              }
            }

            .foo-volume {
              margin: 0 30px;

              .volume-slider {
                margin-left: 10px;
                width: 100px;
              }
            }
          }
        }

        @media screen and (max-width: 1680px) {
          .foo-right {
            .foo-media {
              .foo-media-slider {
                margin: 0 15px;
                width: 150px;
              }
            }

            .foo-volume {
              margin: 0 10px;
            }
          }
        }

        @media screen and (max-width: 1580px) {
          .foo-right {
            .foo-media {
              .foo-media-slider {
                margin: 0 15px;
              }
            }

            .foo-volume {
              margin: 0 5px;
            }
          }
        }
      }
    }
  }

  #hi_popup_video {
    /*.modal-16by9 {
      aspect-ratio: 16/9;
    }

    .modal-content {
      height: 100%;

      .modal-body {
        display: flex;
        align-items: center;
      }

      .footer {
        padding: var(--bs-modal-padding);
      }
    }*/

    border-radius: 8px;

    .video-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 100%;
      height: 50px;
      align-items: center;
      position: absolute;
      top: 0px;
      left: 0px;
      background-color: rgba(255, 255, 255, 0.3);
      z-index: 1;
      padding: 15px 15px;

      button {
        width: 4%;
        margin: 0;
      }
    }

    .video-body {
      flex: 1;
      border-radius: 8px;
    }

    .content {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
    }

    .video-content {
      position: relative;
      width: 100%;
      border-radius: 8px;
      aspect-ratio: 16/9;
    }
    video {
    }
  }
}

// 全屏的樣式
.sketchpad-full {
  background: #fff;

  .sketchpad-head {
    width: auto;
    position: fixed;
    top: 10px;
    right: 20px;
  }

  .sketchpad-box {
    height: 100%;

    .sketchpad-box-left {
      position: absolute;
      top: calc(50% - 315px);
      left: 25px;
      overflow: visible;
    }

    .sketchpad-box-right {
      width: 100%;
      height: 100%;

      #whiteboardContainer {
        // background-color: #d60839;
      }

      .sketchpad-box-right-head {
        width: 100%;
        height: 100%;
        border-radius: 0;
      }
    }
  }

  .sketchpad-full-left {
    position: fixed;
    top: 0;
    left: 0;
    width: 30px;
    height: 100vh;
  }

  .sketchpad-full-bottom {
    z-index: 1;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100vw;
    height: 30px;
  }
}

.sketchpad-box-right-bottom {
  z-index: 2;
  padding: 40px 25px 25px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 130px;

  .bottom-slider {
    width: 100%;
    height: 40px;
  }

  .bottom-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .bottom-box-left {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
      overflow: hidden;

      .bottom-media-time {
        margin: 0 16px;
        color: #000;
        font-size: 14px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 290;
        line-height: normal;
      }

      .bottom-media-div {
        color: #000;
        font-size: 13px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      .bottom-media-music {
        cursor: pointer;
        user-select: none;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 16px;
          height: 16px;
        }
      }

      .bottom-media-select {
        flex: 0 1 180px;
        min-width: 80px;
        height: 30px;
        border-radius: 4px;
        position: relative;

        ::v-deep .el-select {
          width: 100%;
          height: 100%;

          .el-input {
            width: 100%;
            height: 100%;

            .el-input__inner {
              padding: 5px 34px 5px 14px;
              width: 100%;
              height: 100%;
              border: 1px solid rgba(0, 0, 0, 0.2);
              color: #323130;
              font-size: 12px;
              font-family: Microsoft JhengHei;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }

            .el-input__suffix {
              display: none;
            }
          }
        }

        .bottom-media-select-div {
          position: absolute;
          top: 5px;
          right: 10px;
          width: 20px;
          height: 20px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .bottom-box-right {
      display: flex;
      align-items: center;
      flex-shrink: 0;

      .bottom-media-volume {
        cursor: pointer;
        user-select: none;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .bottom-media-slider {
        margin: 0 10px;
        width: 80px;
        flex-shrink: 1;
        min-width: 50px;
      }
    }

    .bottom-media-btn {
      cursor: pointer;
      user-select: none;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background: #f3f4f6;
      }

      img {
        width: 24px;
        height: 24px;
      }

      .img1 {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.video-footer {
  z-index: 2;
  padding: 10px 25px 25px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 110px;
  background-color: rgba(255, 255, 255, 0.3);

  .bottom-slider {
    width: 100%;
    height: 40px;
  }

  .bottom-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .bottom-box-left {
      display: flex;
      align-items: center;

      .bottom-media-time {
        margin: 0 16px;
        color: #ffffff;
        font-size: 14px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 290;
        line-height: normal;
      }

      .bottom-media-div {
        color: #ffffff;
        font-size: 13px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      .bottom-media-music {
        cursor: pointer;
        user-select: none;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 16px;
          height: 16px;
        }
      }

      .bottom-media-select {
        width: 180px;
        height: 30px;
        border-radius: 4px;
        position: relative;

        ::v-deep .el-select {
          width: 100%;
          height: 100%;

          .el-input {
            width: 100%;
            height: 100%;

            .el-input__inner {
              padding: 5px 34px 5px 14px;
              width: 100%;
              height: 100%;
              border: 1px solid rgba(0, 0, 0, 0.2);
              color: #323130;
              font-size: 12px;
              font-family: Microsoft JhengHei;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }

            .el-input__suffix {
              display: none;
            }
          }
        }

        .bottom-media-select-div {
          position: absolute;
          top: 5px;
          right: 10px;
          width: 20px;
          height: 20px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .bottom-box-right {
      display: flex;
      align-items: center;

      .bottom-media-volume {
        cursor: pointer;
        user-select: none;
        width: 40px;
        height: 40px;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 24px;
          height: 24px;
        }
      }

      .bottom-media-slider {
        margin: 0 30px 0 10px;
        width: 130px;
      }
    }

    .bottom-media-btn {
      cursor: pointer;
      user-select: none;
      width: 40px;
      height: 40px;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;

      // &:hover {
      //   background: #f3f4f6;
      // }

      img {
        width: 24px;
        height: 24px;
      }

      .img1 {
        width: 16px;
        height: 16px;
      }
    }
  }
}

.box-div {
  padding: 10px;
  display: flex;
  align-items: center;

  .tool-btn,
  .tool-btns {
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.tool-btn {
  user-select: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;

  &:hover {
    background: #f2f2f2;
  }

  img {
    width: 24px;
    height: 24px;
  }

  div {
    width: 20px;
    height: 20px;
  }
}

.tool-btns {
  user-select: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: #418ef2;

  img {
    width: 24px;
    height: 24px;
  }

  div {
    width: 20px;
    height: 20px;
  }
}

.box-imgList {
  padding: 10px;
  max-width: 370px;
  max-height: 370px;
  overflow-y: auto;

  .box-imgList-div {
    user-select: none;
    cursor: pointer;
    width: 70px;
    height: 70px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;

    &:hover {
      background: #f2f2f2;
    }

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .box-imgList-divs {
    user-select: none;
    cursor: pointer;
    width: 70px;
    height: 70px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    background: #418ef2;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.disabled {
  cursor: no-drop;
  pointer-events: none;
  opacity: 0.6;
}

.blur {
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}

.screenEntry-box {
  .box-h3 {
    color: #000;
    text-align: center;
    font-size: 18px;
    font-family: Microsoft JhengHei;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .box-h5 {
    margin-top: 12px;
    color: #666;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft JhengHei;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .box-btn {
    margin-top: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      user-select: none;
      cursor: pointer;
      width: 230px;
      height: 48px;
      border: none;
      border-radius: 4px;
      background: linear-gradient(180deg, #71afff 0%, #418ef2 100%);
      color: #fff;
      text-align: center;
      p {
        width: 100%;
        color: #fff;
        font-size: 15px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0;
      }
      span {
        color: #fff;
        font-size: 12px;
        font-family: Microsoft JhengHei;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
}
</style>
<style>
/* 修改彈窗原生樣式 */
.sketchpad-popover {
  padding: 0 !important;
}

.sketchpad-popovers {
  min-width: 40px;
  padding: 15px 0 !important;
  display: flex;
  justify-content: center;
}

.picker_wrapper {
  height: fit-content;
  border-radius: 10px;
}

.arrow {
  stroke: #000000;
  stroke-width: 2;
  marker-end: url(#arrow);
}

.active {
  background: rgba(204, 211, 213, 0.87);
}

.textBox.active {
  border: 1px dashed gray;
}

.textBox > .removeIcon,
.textBox > .moveIcon {
  display: none;
}

.textBox.active > .removeIcon,
.textBox.active > .moveIcon {
  display: block;
}

.mobile {
  touch-action: none;
}

.clickable {
  touch-action: auto;
  pointer-events: auto;
}

.scroll-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}

/* Custom scrollbar container */
.custom-scrollbar {
  position: absolute;
  right: -14px;
  top: 0;
  height: 100%;
  width: 14px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
}

.scrollbar-thumb {
  position: absolute;
  width: 100%;
  background-color: #888;
  border-radius: 4px;
  cursor: pointer;
}

.custom-scrollbar-horizontal {
  height: 14px;
  background: #eee;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 10;
}

.scrollbar-thumb-horizontal {
  position: absolute;
  top: 0;
  height: 100%;
  background: #888;
  border-radius: 4px;
  cursor: pointer;
}

#whiteboardContainer {
  overflow: auto;
  -webkit-overflow-scrolling: touch; /* ensures momentum scrolling on iOS */
  touch-action: auto;
}

#whiteboardContainer::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background: transparent;
}

#whiteboardContainer::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.scrollbar-thumb:active {
  cursor: grabbing;
}

.scrollbar-thumb-horizontal:active {
  cursor: grabbing;
}

#mouseOverlay {
  touch-action: none;
}
</style>
